import React, { useState, useEffect, useRef } from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import axios from "axios";
import base_url from "../../api/bootapi";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Col, Row, Button } from "reactstrap";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import moment from "moment";
import { useForm, Controller, set } from "react-hook-form";
import { CountryDropdown } from "react-country-region-selector";
import Swal from "sweetalert2";
import AsyncSelect from "react-select/async";
import ReactDOMServer from "react-dom/server";
import PrintNote from "./PrintNote";
import attachmenturl from "./../../api/attachmenturl";
import "./dashboard.css";
import Footer from "../../components/footer/Footer";
import Nav from "../../components/nav/Nav";
import CustomButton from "../../components/CustomButton";
import { ReactComponent as DownloadIcon } from "../../assets/download.svg";
import { ReactComponent as DocumentIcon } from "../../assets/Document.svg";
import { ReactComponent as FlyClaimIcon } from "../../assets/header button.svg";
import { ReactComponent as AttachmentIcon } from "../../assets/Attachment.svg";
import { ReactComponent as CommentButtonIcon } from "../../assets/CommentButton.svg";
import { ReactComponent as EditButtonIcon } from "../../assets/editbutton.svg";
import { ReactComponent as ImageIcon } from "../../assets/imageIcon.svg";
import { ReactComponent as DocumentFileIcon } from "../../assets/DocumentFileIcon.svg";
import { ReactComponent as DotsHorizontalIcon } from "../../assets/dots-horizontal.svg";
import { ReactComponent as ChevronRight } from "../../assets/chevron-right.svg";
import { ReactComponent as TrashIcon } from "../../assets/trash.svg";
import { ReactComponent as Avatar } from "../../assets/Avatar.svg";
import { ReactComponent as EditCrossIcon } from "../../assets/editCrossIcon.svg";
import { ReactComponent as EditTickButton } from "../../assets/EditTickButton.svg";
import { Modal, Table } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import UploadFile from "../../components/uploadFile/UploadFile";
import { Menu, Text,Tooltip } from "@mantine/core";
// import MessageModal from "../../components/Modals/MessageModal.js";
import ViewFileModal from "../../components/Modals/ViewFileModal.js";
import { use } from "react";
// import { ToastContainer, toast } from "react-toastify";

// import 'react-toastify/dist/ReactToastify.css';

const IndividualClaim = () => {
  const { user } = useSelector((state) => state.user);
  const boardingPassRef = useRef(null);
  const powerOfAttorneyRef = useRef(null);
  const poaRef = useRef(null);
  const airlineResponseRef = useRef(null);
  const baggageClaimRef = useRef(null);
  const additionalExpencesRef = useRef(null);
  const passportRef = useRef(null);
  const addionalFilesRef = useRef(null);
  const otherClaimFilesRef = useRef([]);
  const subClaimFilesRef = useRef({});
  const customStylesAttachment = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
    },
    content: {
      width: "60%",
      maxHeight: "90vh",
      height: "auto",
      // minHeight: "20vh",
      margin: "auto",
      padding: "20px 40px",
      borderRadius: "12px",
      textAlign: "center",
      // overflowY: "auto",
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
      // alignItems: "center",
      // justifyContent: "center"
    },
  };
  let params = useParams();
  const claim_id = params.claim_id;

  const [familyMembers, setFamilyMembers] = useState([]);
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    control,
    watch,
  } = useForm();
  const powerRef = useRef(null);

  const [backdropopen, setbackdropopen] = useState(false);
  const [country1, setcountry] = useState("United States");
  const [countryValid, setCountryValid] = useState(false);

  const [documentNoteOpened, setDocumentNoteOpened] = useState(false);
  const [documentNote, setDocumentNote] = useState("");
 



  const [defaultOptions, setDefaultOptions] = useState([]);
  const [defaultAirlineOptions, setDefaultAirlineOptions] = useState([]);

  const [selectedOriginOption, setSelectedOriginOption] = useState(null);
  const [selectedDestOption, setSelectedDestOption] = useState(null);
  const [selectedAirlineOption, setSelectedAirlineOption] = useState(null);
  const [selectedHomeOption, setSelectedHomeOption] = useState(null);
  const [signUrl, setSignUrl] = useState(null);

  const [selectedHour, setSelectedHour] = useState("");
  const [selectedMinute, setSelectedMinute] = useState("");
  const [hourStatus, setHourStatus] = useState(false);
  const [minStatus, setMinStatus] = useState(false);

  const [optionsList, setOptionsList] = useState([]);
  const [isOpenList, setIsOpenList] = useState(false);
  const [selectedAdditionalFiles, setSelectedAdditionalFiles] = useState(null);
  const [selectedPassportSubClaim, setSelectedPassportSubClaim] = useState([]);
  const [isTermsChecked, setIsTermsChecked] = useState(false);
  const [isAgreementChecked, setIsAgreementChecked] = useState(false);
  const [isPowerOfAttorneyChecked, setIsPowerOfAttorneyChecked] =
    useState(false);
  const [pdfBlob, setPdfBlob] = useState(null);
  const [signatureCaptured, setSignatureCaptured] = useState(false);
  const [isTermsLinkClicked, setIsTermsLinkClicked] = useState(false);
  const [isAgreementLinkClicked, setIsAgreementLinkClicked] = useState(false);
  const [isPowerLinkClicked, setIsPowerLinkClicked] = useState(false);
  const [envolpeId, setEnvelopeId] = useState();
  const [isFetching, setIsFetching] = useState(false);
  const [isDocuSignModalOpen, setIsDocusignModalOpen] = useState(false);
  const [documentFetched, setDocumentFetched] = useState(false);
  const [intervalId, setIntervalId] = useState(null);
  const [isDocumentFetching, setIsDocumentFetching] = useState(false);
  const [triggerIndex, setTriggerIndex] = useState(null);
  const [dataToStore, setDataToStore] = useState(null);
  const [triggerFrom, setTriggerFrom] = useState("original");
  const [email, setEmail] = useState(null);

  const [claimData, setClaimData] = useState({});
  const [previousNote, setPreviousNote] = useState("");
  const [boardingImg, setBoardingImg] = useState();
  const [passportImg, setPassportImg] = useState();
  const [poaImg, setPoaImg] = useState();
  const [baggageImg, setBaggageImg] = useState();
  const [expenceImg, setExpenceImg] = useState();
  const [agreement, setAgreement] = useState();
  const [additionalImg, setAdditionalImg] = useState();

  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [imageModalTitle, setImageModalTitle] = useState("");
  const [imageModalFileUrl, setImageModalFileUrl] = useState("");
  const [isSubmitBtnDisabled, setIsSubmitBtnDisabled] = useState(true);

  const boardingPass = watch("boarding_pass");
  const passport = watch("passport");
  const agreementFile = watch("agreement");
  const powerOfAttorney = watch("powerPdf");

  const [otherDoc, setOtherDoc] = useState([]);
  const [memberAddtionalDoc, setMemberAdditionalDoc] = useState([]);
  const [previousTimeline, setPreviousTimeline] = useState("");


  const [customerCareNote, setCustomerCareNote] = useState("");

  function getClaimType(type) {
  switch (type) {
    case "overbooking":
      return "Denied boarding";
    
    case "denied_boarding":
      return "Denied boarding";

    case "lost_baggage":
      return "Lost luggage";

    case "damage_baggage":
      return "Damaged luggage";

    case "travel_expenses":
      return "Travel expenses";

    case "delayed_baggage":
      return "Delayed luggage";
    
    case "delayed":
      return "Delayed";
    
    case "cancelled":
      return "Cancelled";
    
    case "lost/damaged":
      return "Lost/Damaged";
    
    case "lost_wages":
      return "Lost Wages";
    
    case "other":
      return "Others";
    
     case "others":
      return "Others";
    
   
    

    default:
      return type;
  }
}

  const isFileUploaded = (fileField) => {
    return fileField?.length > 0;
  };

  useEffect(() => {
    const formData = watch();
    console.log("formdata", formData.boarding_pass);
    const isChanged =
      isFileUploaded(formData.boarding_pass) ||
      isFileUploaded(formData.passport) ||
      isFileUploaded(formData.agreement) ||
      isFileUploaded(formData.powerPdf);
    console.log("ischanged", isChanged);
    setIsSubmitBtnDisabled(isChanged);
  }, [boardingPass, passport, agreementFile, powerOfAttorney]);

  const [note, setNote] = useState();

  const [flightDetails, setFlightDetails] = useState([
    {
      id: null,
      airline: "",
      flight_number: "",
      airport_of_origin: "",
      airport_of_destination: "",
      date_of_travel: "",
      original_departure_time: "",
      original_arrival_time: "",
      original_departure_date: "",
      original_arrival_date: "",
      // original_departure: "",
      // original_arrival: "",
      hub_code: "",

      delayed: false,
      cancelled: false,
      missed: false,
      flight_class: "",
    },
  ]);

  // console.log("148--->",flightDetails);

  const [actualFlightDetails, setActualFlightDetails] = useState([
    {
      id: null,
      actual_airline: "",
      actual_flight_number: "",
      actual_airport_of_origin: "",
      actual_airport_of_destination: "",
      actual_date_of_travel: "",
      actual_departure_time: "",
      actual_arrival_time: "",
      actual_departure_date: "",
      actual_arrival_date: "",

      actual_hub_code: "",
      provided_by_airline: false,
      self_booked: false,
      actual_flight_class: "",
    },
  ]);
  const iframeRef = useRef(null);
  const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);

  const openMessageModal = () => {
    setIsMessageModalOpen(true);
  };
  const closeMessageModal = () => {
    setIsMessageModalOpen(false);
  };

const getDelayDuration = (duration) => {
  if (duration === null || duration === undefined || duration === "") return "N/A";

  const parsedStr = String(duration).match(/-?\d+/)?.[0];
  const parsed = parseInt(parsedStr, 10);
  if (Number.isNaN(parsed)) return "N/A";

  if (parsed === 0) return "0m";

  const sign = parsed < 0 ? "-" : "";
  const totalMinutes = Math.abs(parsed);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  if (hours === 0) return `${sign}${minutes}m`;
  if (minutes === 0) return `${sign}${hours}hr`;
  return `${sign}${hours}hr ${minutes}m`;
};

  const [notes, setNotes] = useState("");
  const handlePrint = () => {
    const iframe = iframeRef.current;
    const doc = iframe.contentDocument || iframe.contentWindow.document;

    // Clear previous content
    doc.body.innerHTML = "";

    // Create a container element for styling
    const container = doc.createElement("div");
    container.style.fontFamily = "Arial, sans-serif";
    container.style.fontSize = "16px";
    container.style.color = "#555";

    console.log("Claim Data", claimData);
    // Render StyledNote component as HTML string
    const printNote = (
      <PrintNote
        note={note}
        claimId={params.claim_id}
        claimData={claimData}
        flightDetails={flightDetails}
        actualFlightDetails={actualFlightDetails}
        otherDoc={otherDoc}
        familyMembers={familyMembers}
        getpaymentData={getpaymentData}
        additionalClaimDetails
      />
    );

    console.log(previousNote);

    const htmlString = ReactDOMServer.renderToStaticMarkup(printNote);

    // Set the HTML content to the iframe body
    doc.body.innerHTML = htmlString;

    // Focus and print
    iframe.contentWindow.focus();
    iframe.contentWindow.print();
  };

  const [delay, setDelay] = useState("00:00");

  const [flightOptions, setFlightOptions] = useState({});

  const [ticketNumberErrors, setTicketNumberErrors] = useState(
    Array(familyMembers.length).fill("")
  );

  const openImageViewModal = (title, fileUrl) => {
    setImageModalTitle(title);
    setImageModalFileUrl(fileUrl);
    setImageModalOpen(true);
  };
  const closeImageModal = () => {
    setImageModalOpen(false);
  };

  const isImageFile = (url) => {
    // Example function to check if the URL ends with a common image file extension
    return /\.(jpeg|jpg|png|gif)$/i.test(url);
  };

  const handleViewFile = (elem) => {
    if (!elem) {
      return;
    }
    //console.log("Element", attachmenturl + elem);
    const fileUrl = base_url.api1 + elem;
    if (!isImageFile(fileUrl)) {
      window.open(fileUrl, "_blank");
    } else {
      openImageViewModal("View File", fileUrl);
    }
  };

  const removeFamilyMember = (index, id) => {
    if (id !== null) {
      removeFamilyMemberData(id);
    }
    const updatedFamilyMember = familyMembers.filter((_, i) => i !== index);
    setFamilyMembers(updatedFamilyMember);
  };

  const removeFamilyMemberData = (id) => {
    setbackdropopen(true);

    axios
      .delete(`${base_url.api1}/tourapp/sub_claim_delete?id=${id}`, {})
      .then(() => {
        setbackdropopen(false);
      })
      .catch(() => {
        setbackdropopen(false);
      });
  };
  const getIsUpdatedDisable = () => {
    if (
      addtionalFiles.length > 0 ||
      Object.keys(claimFiles).length > 0 ||
      updatedAddionalClaims.length > 0 ||
      updatedSubClaim.length > 0
    ) {
      return true;
    }

    return false;
  };
  const renderViewFileInput = (claim) => {
    if (claim) {
      const fileName = getShortenedFileNameForTravelers(claim);
      return (
        <div>
          <button
            className="individual-claim-view-file-button"
            onClick={() => handleViewFile(claim)}
            type="button"
            style={{ width: "100%", color: "#222222", fontWeight: "400" }}
          >
            {/* View File */}
            <DocumentIcon />
            {claim ? getShortenedFileNameForTravelers(fileName) : "No File"}
          </button>
        </div>
      );
    } else {
      // return (
      //   <div>
      //     <button
      //       className="btn btn-secondary"
      //       disabled={!claim}
      //       style={!claim ? { cursor: "not-allowed" } : {}}
      //       type="button"
      //     >
      //       No File
      //     </button>
      //   </div>
      // );
      return null;
    }
  };

  const handlePassportUpload = (e, index) => {
    const file = e.target.files[0];
    const updatedFamilyMember = [...familyMembers];
    updatedFamilyMember[index]["passport"] = file;
    updatedFamilyMember[index]["passport_name"] = `sub_claim_${index + 1}`;
    setFamilyMembers(updatedFamilyMember);
    setIsSubmitBtnDisabled(true);
  };

  const handleAddressChange = (option) => {
    setValue("address", option.label);
    setOptionsList([]);
    setIsOpenList(false);
  };
  const handleInputBlur = () => {
    setTimeout(() => {
      setIsOpenList(false);
    }, 100);
  };
  const [updating, setUpdating] = useState(false);

  const [signerDetails, setSignerDetails] = useState([]);

  const getSignerDetails = () => {
    setbackdropopen(true);
    axios
      // https://api.linsoatours.com/tourapp/compensation/signers?claim_id=435
      .get(
        `${base_url.api1}/tourapp/compensation/signers?claim_id=${params.claim_id}`
      )
      .then((response) => {
        console.log("Signer Details:", response.data);
        setSignerDetails(response.data.signers || []);

        // handleCheckSignerStatus(response.data.signers || [])

        setbackdropopen(false);
      })
      .catch((error) => {
        console.error("Error fetching signer details:", error);
        setbackdropopen(false);
      });
  };
  // Fetch initial data
  useEffect(() => {
    getClaimDetails();
    getPaymentDetails();
    getSignerDetails();
  }, [updating]);


  const handleCheckSignerStatus = async (signers=signerDetails) => {
    if (signers?.length > 0) {
       await Promise.all(
  signers
    .filter((r) => !r.signed)
    .map((r) => handleCheckStatus(r)));
    }
 

}

  console.log("Signer Details: =================> ", signerDetails);

  const fetchAirlines = async (inputValue) => {
    if (inputValue.length > 0) {
      try {
        const response = await axios.get(
          `${base_url.api1}/tourapp/airline_list?search=${inputValue}`
        );
        if (response.data && response.data.airlines) {
          return response.data.airlines.map((airline) => ({
            value: airline.id,
            label: airline.airline_name,
            hub_code: airline.iata_code,
          }));
        }
      } catch (error) {
        console.error("Error fetching airlines:", error);
      }
    }
    return [];
  };

  const handleAdditionalFileChange = (e) => {
    setSelectedAdditionalFiles(e.target.files);
    setIsSubmitBtnDisabled(true);
  };

  const loadOptions = (inputValue, callback) => {
    fetchAirports(inputValue).then((options) => callback(options));
  };

  const fetchAirports = async (inputValue) => {
    if (inputValue.length > 0) {
      try {
        const response = await axios.get(
          `${base_url.api1}/tourapp/airport_list?search=${inputValue}`
        );
        if (response.data && response.data.Airports) {
          return response.data.Airports.map((airport) => ({
            value: airport.id,
            label: airport.airport_name,
          }));
        }
      } catch (error) {
        console.error("Error fetching airports:", error);
      }
    }
    return [];
  };

  const loadAirlineOptions = (inputValue, callback) => {
    fetchAirlines(inputValue).then((options) => callback(options));
  };

  const [pdfData, setPdfData] = useState(null);

  const [isAgreementModalOpen, setAgreementModalOpen] = useState(false);
  const [isPowerModalOpen, setIsPowerModalOpen] = useState(false);
  const [powerPdf, setPowerPdf] = useState(null);

  const [additionalClaimDetails, setAdditionalClaimDetails] = useState([]);
  const handlePowerPDF = (base64PDF) => {
    const pdfBlob = base64ToBlob(base64PDF, "application/pdf");

    setPowerPdf(pdfBlob);

    const pdfUrl = URL.createObjectURL(pdfBlob);
    window.open(pdfUrl, "_blank");
  };

  const addFamilyMember = () => {
    setFamilyMembers([
      ...familyMembers,
      {
        id: null,
        first_name: null,
        last_name: null,
        date_of_birth: null,
        passport_number: null,
        ticket_number: null,
        passport: null, // Initialize as null or handle file object
        passport_name: null,
        additional_docu: null,
        additionalDoc_name: null,
      },
    ]);
  };

  const handleAdditionalUpload = (e, index) => {
    const file = e.target.files[0];
    const updatedFamilyMember = [...familyMembers];
    updatedFamilyMember[index]["additional_docu"] = file;
    updatedFamilyMember[index]["additionalDoc_name"] = `sub_doc_claim_${
      index + 1
    }`;
    setFamilyMembers(updatedFamilyMember);
    setIsSubmitBtnDisabled(true);
  };

  const handleTicketNumberChange = (e, index) => {
    const value = e.target.value.replace(/\D/g, "");
    let errorMessage = "";
    if (value.length > 13) {
      return;
    }

    if (!value) {
      errorMessage = "Ticket Number is Required";
    } else if (value.length !== 13) {
      errorMessage = "Ticket Number must be 13 digits";
    }
    const updatedErrors = [...ticketNumberErrors];
    updatedErrors[index] = errorMessage;
    setTicketNumberErrors(updatedErrors);

    setFamilyMembers((prevMembers) => {
      const updatedMembers = [...prevMembers];
      updatedMembers[index] = {
        ...updatedMembers[index],
        tickets: value,
      };
      return updatedMembers;
    });
    setIsSubmitBtnDisabled(true);
  };

  const handleInputChange = (e, index, fieldName) => {
    const { value } = e.target;
    setFamilyMembers((prevMembers) => {
      const updatedMembers = [...prevMembers];
      updatedMembers[index] = {
        ...updatedMembers[index],
        [fieldName]: value,
      };
      return updatedMembers;
    });
    setIsSubmitBtnDisabled(true);
  };

  const base64ToBlob = (base64, contentType) => {
    const byteCharacters = atob(base64);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  };

  const getClaimDetails = () => {
    setbackdropopen(true);

    axios
      .get(
        `${base_url.api1}/tourapp/compensation_request?id=` + params.claim_id
      )
      .then((response) => {
        let claimDetails = response.data.Compensation;

        //console.log("Sub CLaims-->", claimDetails.sub_claims);
        setClaimData({
          first_name: claimDetails.first_name,
          last_name: claimDetails.last_name,
          address: claimDetails.address,
          passport_number: claimDetails.passport_number,
          unit:claimDetails.unit,
          nationality: claimDetails.nationality,
          date_of_birth: claimDetails.date_of_birth,
          payment_method: claimDetails.payment_method,
          payment_status: claimDetails.payment_status,
          amount: claimDetails.amount,
          payment_sent_at: claimDetails.payment_sent_at,
          // airline: claimDetails.airline,
          // flight_number: claimDetails.flight_number,
          // airpotr_of_origin: claimDetails.airpotr_of_origin,
          // airpotr_of_destination: claimDetails.airpotr_of_destination,
          unique_code: claimDetails.unique_code,
          contact_no: claimDetails.contact_no,
          // note: claimDetails.note,
          airline_res_no: claimDetails.airline_res_no,
          ticket_ref_no: claimDetails.ticket_ref_no,
          email_id: claimDetails.email_id,
          unique_claim_id:claimDetails.unique_claim_id,
          status: claimDetails.status,
          receive_any_compensation: claimDetails.receive_any_compensation,
          delay_duration_minutes:claimDetails?.delay_duration_minutes || null,
          type_of_claim: claimDetails.type_of_claim, // date_of_travel: claimDetails.date_of_travel,
          tickets: claimDetails.tickets,
          claim_id: claimDetails.contact_no,
          state: claimDetails.state,
          city: claimDetails.city,
          claim_amount:claimDetails.claim_amount,
          num_of_passenger: claimDetails.num_of_passenger,
          postal_code: claimDetails.postal_code,
          // airline_res_no: claimDetails.airline_res_no,
          source_of_claim: claimDetails.source_of_claim,
          created_date: claimDetails.created_date,
          updated_date: claimDetails.updated_date,
          airline_response: claimDetails.airline_response,
          agreement: claimDetails.agreement,
          power_of_attorney: claimDetails.power_of_attorney,
          baggage_claim: claimDetails.baggage_claim,
          additional_exp: claimDetails.additional_exp,
          airline_poa: claimDetails.airline_poa,
          claim_details: claimDetails?.claim_details || null,
          delay: claimDetails.delay || "No",
          luggage_delivered: claimDetails?.luggage_delivered,
          agreement_signed: claimDetails?.agreement_signed,
          agreement_url: claimDetails?.agreement_url,
          envelope_id:claimDetails?.envelope_id,
        });


        if (!claimDetails?.agreement_signed) {
          openAgreementAlertModal()
        }
        setcountry(claimDetails.nationality);
        setCountryValid(false);
        setBoardingImg(claimDetails.boarding_pass);
        setAdditionalImg(claimDetails.additional_exp);
        setPassportImg(claimDetails.passport);
        setAgreement(claimDetails.agreement);
        setPoaImg(claimDetails.airline_poa);
        setBaggageImg(claimDetails.baggage_claim);

        setPreviousTimeline(claimDetails.claim_logs);
        setNote(claimDetails.note);
        setOtherDoc(claimDetails.other_doc);
        setAdditionalClaimDetails(claimDetails.other_claims || []);
        setFamilyMembers(claimDetails.sub_claims);
      const allAddionalDocs = claimDetails.sub_claims
  .filter(member => member.additional_doc) // keep only members with a document
  .map(member => ({
    document: member.additional_doc
  }));
        setMemberAdditionalDoc([...allAddionalDocs, ...claimDetails.other_doc]);
        console.log([...allAddionalDocs, ...claimDetails.other_doc])
        setPowerPdf(claimDetails.power_of_attorney);

     
        if (claimDetails?.flight_details) {
          const transformedFlightDetails = claimDetails.flight_details.map(
            (flight) => {
              
             
              
              return{


              

                id: flight.id || null, // Use id if provided, else null
                airline: flight.airline || null,
                flight_number: flight.flight_number || null,
                airport_of_origin: flight.airport_of_origin || null,
                airport_of_destination: flight.airport_of_destination || null,
                date_of_travel: flight.date_of_travel || null,
                original_departure_time: flight.scheduled_departure
                  ? moment.parseZone(flight.scheduled_departure).format("HH:mm")
                  : null,
                original_arrival_time: flight.scheduled_arrival
                  ? moment.parseZone(flight.scheduled_arrival).format("HH:mm")
                  : null,
                original_departure_date: flight.scheduled_departure
                  ? moment
                    .parseZone(flight.scheduled_departure)
                    .format("YYYY-MM-DD")
                  : null,
                original_arrival_date: flight.scheduled_arrival
                  ? moment
                    .parseZone(flight.scheduled_arrival)
                    .format("YYYY-MM-DD")
                  : null,
                delayed: flight.delayed || false,
                cancelled: flight.cancelled || false,
                missed: flight.missed || false,
                airline_res_no: flight.airline_res_no || null,
                flight_class: flight.flight_class || null,
                ticket_ref_no: flight.ticket_ref_no || null,
                delay_duration_minutes: flight.delay_duration_minutes || null,
                additional_details:flight?.additional_details || ""
              }
              
            }
          );

          setFlightDetails(transformedFlightDetails);
        }

 
        if (claimDetails?.actual_flight_details) {
          const transformedActualFlightDetails =
            claimDetails.actual_flight_details.map((flight) => ({
              id: flight.id || null, // Use id if provided, else null
              actual_airline: flight.actual_airline || null,
              actual_flight_number: flight.actual_flight_number || null,
              actual_airport_of_origin: flight.actual_airport_of_origin || null,
              airline_res_no: flight.airline_res_no || null,
              actual_airport_of_destination:
                flight.actual_airport_of_destination || null,
              actual_date_of_travel: flight.actual_date_of_travel || null,
              actual_departure_time: flight.actual_departure
                ? moment.parseZone(flight.actual_departure).format("HH:mm")
                : null,
              actual_arrival_time: flight.actual_arrival
                ? moment.parseZone(flight.actual_arrival).format("HH:mm")
                : null,
              actual_departure_date: flight.actual_departure
                ? moment.parseZone(flight.actual_departure).format("YYYY-MM-DD")
                : null,
              actual_arrival_date: flight.actual_arrival
                ? moment.parseZone(flight.actual_arrival).format("YYYY-MM-DD")
                : null,
              provided_by_airline: flight.provided_by_airline,
              self_booked: flight.self_booked,
              actual_flight_class: flight.actual_flight_class || null,
              ticket_ref_no: flight.ticket_ref_no || null,
            }));

          setActualFlightDetails(transformedActualFlightDetails);
        }
        setDelay(claimDetails?.delay);

        setPreviousNote(claimDetails.note || []);
        setCustomerCareNote(claimDetails.customer_care_note || []);
        setbackdropopen(false);
      })
      .catch((error) => {
        if (error?.response?.data?.status_code == 400) {
          navigate("/claimstatus");
        }
        setbackdropopen(false);
      });
  };

  const [getpaymentData, setpaymentData] = useState([]);

  const getPaymentDetails = () => {
    setbackdropopen(true);

    axios
      .get(`${base_url.api1}/tourapp/claim-payments?claim=` + params.claim_id)
      .then((response) => {
        console.log("636-------->", response.data.Payment);
        setpaymentData(response.data.Payment);
        setbackdropopen(false);
      })
      .catch(() => {
        setpaymentData([]);
        setbackdropopen(false);
      });
  };

  useEffect(() => {
    const updateNotificationState = async () => {
      if (previousNote.length > 0) {
        const updatedNotes = previousNote?.map((note) => {
          if (note.hasOwnProperty("readed_customer")) {
            return { ...note, readed_customer: true }; // change this to readed_customer
          }
          return note;
        });

        const formData = new FormData();

        const formObject = {
          read_note: true,
          note: updatedNotes,
          from_customer: true,
        };
        const jsonFormObject = JSON.stringify(formObject);

        formData.append("data", jsonFormObject);

        const sendMessageUrl = `${base_url.api1}/tourapp/compensation_request?id=${params.claim_id}`;

        await axios
          .put(sendMessageUrl, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Origin: "https://flyandclaim.odisoft.in",
            },
          })
          .then((response) => {
            console.log("note", response.data);
          })
          .catch((error) => {
            console.error("Error deleting message:", error);
          });
      }
    };
    updateNotificationState();
  }, [previousNote, params.claim_id]);




   useEffect(() => {
    const updateNotificationState = async () => {
      if (customerCareNote.length > 0) {
        const updatedNotes = customerCareNote?.map((note) => {
          if (note.hasOwnProperty("readed_customer")) {
            return { ...note, readed_customer: true }; // change this to readed_customer
          }
          return note;
        });

        const formData = new FormData();

        const formObject = {
          read_note: true,
          customer_care_note: updatedNotes,
          from_customer: true,
        };
        const jsonFormObject = JSON.stringify(formObject);

        formData.append("data", jsonFormObject);

        const sendMessageUrl = `${base_url.api1}/tourapp/compensation_request?id=${params.claim_id}`;

        await axios
          .put(sendMessageUrl, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Origin: "https://flyandclaim.odisoft.in",
            },
          })
          .then((response) => {
            console.log("note", response.data);
          })
          .catch((error) => {
            console.error("Error deleting message:", error);
          });
      }
    };
    updateNotificationState();
  }, [customerCareNote, params.claim_id]);


  function getStatusStyles(status) {
    const styles = {
      "In review": {
        bgColor: "rgba(255, 193, 7, 0.1)", // yellow (light)
        color: "#FFC107", // yellow
      },
      "Waiting for airline": {
        bgColor: "rgba(229, 116, 45, 0.1)", // orange
        color: "#E5742D",
      },
      "Documents needed": {
        bgColor: "rgba(208, 66, 68, 0.1)", // red
        color: "#D04244",
      },
      paid: {
        bgColor: "rgba(33, 150, 243, 0.1)", // blue (light)
        color: "#2196F3",
      },
      approved: {
        bgColor: "rgba(76, 175, 80, 0.1)", // green
        color: "#4CAF50",
      },
      appealed: {
        bgColor: "rgba(255, 152, 0, 0.1)", // deep orange
        color: "#FF9800",
      },
      rejected: {
        bgColor: "rgba(244, 67, 54, 0.1)", // red strong
        color: "#F44336",
      },
      incomplete: {
        bgColor: "rgba(158, 158, 158, 0.1)", // grey
        color: "#9E9E9E",
      },
      pending: {
        bgColor: "rgba(255, 152, 0, 0.1)", // orange
        color: "#FF9800",
      },
    };

    console.log(status);

    return (
      styles[status] || {
        bgColor: "rgba(0, 0, 0, 0.1)", // default bg
        color: "rgba(0, 0, 0, 1)", // default color
      }
    );
  }

  const onSubmit = (data) => {
    // if (!country1) {
    //   setCountryValid(true);
    //   return;
    // }

    //console.log("Sub Claim", subClaims);
    //console.log("data", data);
    //console.log("claimdata", claimData);
    const formData = new FormData();
    // const formatedNote = handleSaveNote();

    // Collecting all form data into a single object

    const flighDetailsData = flightDetails.map((flight) => {
      const newData = {
        airline: flight.airline,
        flight_number: flight.flight_number,
        airport_of_origin: flight.airport_of_origin,
        airport_of_destination: flight.airport_of_destination,
        scheduled_arrival: `${flight.original_arrival_date}T${flight.original_arrival_time}`,
        scheduled_departure: `${flight.date_of_travel}T${flight.original_departure_time}`,
        date_of_travel: flight.date_of_travel,
        delayed: flight.delayed,
        cancelled: flight.cancelled,
        missed: flight.missed,
      };
      if (flight.id !== null) {
        newData.id = flight.id;
      }
      return newData;
    });

    const actualFlighDetailsData = actualFlightDetails.map((flight) => {
      const newData = {
        actual_departure: `${flight.actual_date_of_travel}T${flight.actual_departure_time}`,
        actual_arrival: `${flight.actual_arrival_date}T${flight.actual_arrival_time}`,
        actual_airport_of_origin: flight.actual_airport_of_origin,
        actual_date_of_travel: flight.actual_date_of_travel,
        actual_airport_of_destination: flight.actual_airport_of_destination,
        actual_airline: flight.actual_airline,
        actual_flight_number: flight.actual_flight_number,
        provided_by_airline: flight.provided_by_airline,
        self_booked: flight.self_booked,
      };
      if (flight.id !== null) {
        newData.id = flight.id;
      }
      return newData;
    });

    const subClaimsData = familyMembers.map((claim) => {
      const subClaimData = {
        first_name: claim.first_name,
        last_name: claim.last_name,
        passport_number: claim.passport_number,
        tickets: claim.tickets,
        date_of_birth: claim.date_of_birth,
      };

      if (claim.id !== null) {
        subClaimData.id = claim.id;
      }
      if (claim.passport) {
        subClaimData.passport = claim.passport_name;
        formData.append(claim.passport_name, claim.passport);
      }
      if (claim.additional_docu) {
        subClaimData.additional_doc = claim.additionalDoc_name;
        formData.append(claim.additionalDoc_name, claim.additional_docu);
      }

      return subClaimData;
    });

    //console.log("Sub Claim", subClaimsData);

    const formObject = {
      first_name: data.first_name,
      last_name: data.last_name,
      address: data.address,
      passport_number: data.passport_type_number,
      nationality: country1,
      date_of_birth: data.date_of_birth,

      status: data.status,

      contact_no: data.contact_no,
      email_id: data.email_id,
      receive_any_compensation: data.receive_any_compensation,
      date_of_travel: data.date_of_travel,
      tickets: data.tickets,
      sub_claims: subClaimsData,
      flight_details: flighDetailsData,
      actual_flight_details:
        claimData.type_of_claim === "flight delay / flight cancellation"
          ? actualFlighDetailsData
          : null,
      delay: delay,
      airline_res_no: data.airline_res_no,
    };

    // Convert the form object to JSON
    const jsonFormObject = JSON.stringify(formObject);
    formData.append("boarding_pass", data.boarding_pass[0] || null);
    formData.append("passport", data.passport[0] || null);
    formData.append("agreement", data.agreement[0] || null);
    formData.append("power_of_attorney", data.powerPdf[0] || null);
    // Append the JSON object to the FormData
    formData.append("data", jsonFormObject);

    if (selectedAdditionalFiles) {
      for (let i = 0; i < selectedAdditionalFiles.length; i++) {
        formData.append("document", selectedAdditionalFiles[i]);
      }
    }

    setbackdropopen(true);
    postClaimRequest(formData);
  };

  const postClaimRequest = (data) => {
    axios
      .put(
        `${base_url.api1}/tourapp/compensation_request?id=${claim_id}`,
        data,
        {
          headers: {
            Origin: "https://flyandclaim.odisoft.in",
          },
        }
      )
      .then(
        () => {
          setbackdropopen(false);
          Swal.fire({
            icon: "success",
            title: "Success",
            text: `Changes uploaded successfully.`,
          }).then(() => {
            window.location.reload();
          });
        },
        () => {
          setbackdropopen(false);
        }
      );
  };

  const [status] = useState("In review");
  const [statusTwo] = useState("Processing");

  const elements = [
    {
      submittedDate: "05/08/2024",

      status: "Filed",
      notes: "Claim submitted by customer",
    },
    {
      submittedDate: "05/08/2024",

      status: "Filed",
      notes: "Claim submitted by customer",
    },
    {
      submittedDate: "05/08/2024",

      status: "Filed",
      notes: "Claim submitted by customer",
    },
    {
      submittedDate: "05/08/2024",

      status: "Filed",
      notes: "Claim submitted by customer",
    },
    {
      submittedDate: "05/08/2024",

      status: "Filed",
      notes: "Claim submitted by customer",
    },
    {
      submittedDate: "05/08/2024",

      status: "Filed",
      notes: "Claim submitted by customer",
    },
  ];

  const rows = elements.map((element, index) => (
    <Table.Tr key={index}>
      <Table.Td>{element.submittedDate}</Table.Td>
      <Table.Td>{element.status}</Table.Td>
      <Table.Td>{element.notes}</Table.Td>
    </Table.Tr>
  ));

  const [opened, { open, close }] = useDisclosure(false);
  const [openedAgreementAlertModal, { open: openAgreementAlertModal, close: closeAgreementAlertModal }] =
  useDisclosure(false);

  const [uploadedFile, setUploadedFile] = useState(null);

  const selectStyles = {
    control: (base) => ({
      ...base,
      background: "#e9ecef",
      outline: "none !important",
      border: "1px solid #dde6f2",
      boxShadow: "none !important",
      // width: "250px",
      borderRadius: "20px",
    }),
    menu: (base) => ({
      ...base,
      background: "#ffffff",
    }),
    option: (base, { isFocused, isSelected }) => ({
      ...base,
      background: isSelected
        ? "#007bff"
        : isFocused
        ? "#f0f0f0"
        : "transparent",
      color: isSelected ? "#ffffff" : "#000000",
    }),
  };

  // const handleAirlineResponseViewClick = () => {
  //   // window.open("https://api.linsoatours.com/Images/airline_response/sssss.pdf", "_blank");
  //   window.open(`${base_url.api1}${claimData.airline_response}`, "_blank");
  // }
  // const handleAgreementViewClick = () => {
  //   // window.open("https://api.linsoatours.com/Images/airline_response/sssss.pdf", "_blank");
  //   window.open(`${base_url.api1}${claimData.agreement}`, "_blank");
  // }

  const handleAirlineResponseDownloadClick = async () => {
    try {
      const fileUrl = `${base_url.api1}${claimData.airline_response}`;
      const fileName =
        claimData?.airline_response?.split("/").pop() || "document.pdf";

      // Fetch the file as a blob
      const response = await fetch(fileUrl);
      const blob = await response.blob();

      // Create a download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      link.style.display = "none";

      document.body.appendChild(link);
      link.click();

      // Clean up
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);
    } catch (error) {
      console.error("Download failed:", error);
      // Optionally show error to user
    }
  };

  const handleDownloadClick = async (file_name) => {
    try {
      const fileUrl = `${base_url.api1}${file_name}`;
      const fileName = file_name?.split("/").pop() || "document.pdf";

      // Fetch the file as a blob
      const response = await fetch(fileUrl);
      const blob = await response.blob();

      // Create a download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      link.style.display = "none";

      document.body.appendChild(link);
      link.click();

      // Clean up
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);
    } catch (error) {
      console.error("Download failed:", error);
      // Optionally show error to user
    }
  };

  const handleAgreementDownloadClick = async () => {
    try {
      const fileUrl = `${base_url.api1}${claimData.agreement}`;
      const fileName =
        claimData?.airline_response?.split("/").pop() || "document.pdf";

      // Fetch the file as a blob
      const response = await fetch(fileUrl);
      const blob = await response.blob();

      // Create a download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      link.style.display = "none";

      document.body.appendChild(link);
      link.click();

      // Clean up
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);
    } catch (error) {
      console.error("Download failed:", error);
      // Optionally show error to user
    }
  };

  const [userNote, setUserNote] = useState("");
  const [customerUserNote, setCustomerUserNote] = useState("");

  const getCurrentDateTime = () => {
    return moment().format("h:mm A MMMM D, YYYY");
  };

  const addCustomerNote = (notes, customerNote, filePaths) => {
    const dateTime = getCurrentDateTime();
    // const newNote = {
    //   user: "customer",
    //   note: customerNote,
    //   timestamp: dateTime,
    // };
    const newNote = {
      user: "customer",
      note: customerNote,
      timestamp: dateTime,
      files: filePaths,
      delete_for_me: false,
      is_customer: true,
      is_admin: false,
      readed_admin: false,
      readed_customer: true, // ->>> show in dashboard
      from_customer: true,
    };

    if (!notes) {
      notes = [];
    }

    return [...notes, newNote];
  };


    const addCustomerCareNote = (notes, customerNote, filePaths) => {
    const dateTime = getCurrentDateTime();
    // const newNote = {
    //   user: "customer",
    //   note: customerNote,
    //   timestamp: dateTime,
    // };
    const newNote = {
      user: "customer",
      note: customerNote,
      timestamp: dateTime,
      files: filePaths,
      delete_for_me: false,
      is_customer: true,
      is_admin: false,
      readed_admin: false,
      readed_customer: true, // ->>> show in dashboard
      from_customer: true,
    };

    if (!notes) {
      notes = [];
    }

    return [...notes, newNote];
  };
  const handleUserNoteInputChange = (e) => {
    setUserNote(e.target.value);
  };

  const getSignerName = (signer) => {
    let name = "";

    if (signer) {
      if (typeof signer !== "string") return "";
      name = signer.charAt(0).toUpperCase() + signer.slice(1).toLowerCase();
      if (name.length > 22) {
        name = name.slice(0, 22) + "...";
      }

      return name;
    } else {
      return "";
    }
  };

  // add user note final click function
  const handleUserNoteSubmit = async (e) => {
    e.preventDefault();
    const trimmedNote = userNote.trim();
    if (trimmedNote === "" && selectedFiles.length === 0) {
      return;
    }
    setbackdropopen(true);

    // setUserNoteLoading(true);
    let filePaths = [];
    if (selectedFiles.length > 0) {
      filePaths = await handleNoteFileUpload();
    }
    const updatedNotes = addCustomerNote(previousNote, userNote, filePaths);

    const formData = new FormData();

    const formObject = {
      note: updatedNotes,
      from_customer: true,
    };
    const jsonFormObject = JSON.stringify(formObject);

    formData.append("data", jsonFormObject);

    const sendMessageUrl = `${base_url.api1}/tourapp/compensation_request?id=${params.claim_id}`; // Replace with your actual URL
    setbackdropopen(true);
    await axios
      .put(sendMessageUrl, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Origin: "https://flyandclaim.odisoft.in",
        },
      })
      .then((response) => {
        setUserNote("");
        setSelectedFiles([]);
        getClaimDetails();
        setbackdropopen(false);
      })
      .catch((error) => {
        setUserNote("");
        console.error("Error sending message:", error);
        setbackdropopen(false);
      });
  };

  // add file upload
  const handleNoteFileUpload = async () => {
    if (selectedFiles.length === 0) {
      // alert("No files selected to upload");
      return;
    }
    try {
      const formData = new FormData();
      selectedFiles.forEach(({ file }) => {
        formData.append("comment_file", file);
      });

      const response = await axios.post(
        `${base_url.api1}/tourapp/claim-file`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log("Files uploaded successfully:", response.data);
      // alert("Files uploaded successfully!");

      const filePaths = response.data.data.map((file) => file.comment_file);
      return filePaths;
      // } else {
      //   alert("No files selected.");
      // }
    } catch (error) {
      console.error("Error uploading files:", error);
    setbackdropopen(false);

      // alert("An error occurred while uploading files.");
    }
  };

  const [selectedFiles, setSelectedFiles] = useState([]);

  const handleNoteSelectedFiles = async (event) => {
    const files = Array.from(event.target.files);
    if (files.length > 0) {
      setSelectedFiles((prevFiles) => [
        ...prevFiles,
        ...files.map((file) => ({ file })),
      ]);
      console.log(`Stored ${files.length} files`);
    }
  };

  // console.log(selectedFiles);

  const openFilePicker = (type) => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = type === "image" ? "image/*" : "*/*";
    input.multiple = true;
    input.onchange = (e) => {
      console.log("File selected:", e.target.files);
      handleNoteSelectedFiles(e);
    };
    input.click();
  };

  // edit note file upload
  const handleEditNoteFileUpload = async () => {
    if (editSelectedFiles.length === 0) {
      // alert("No files selected to upload");
      return;
    }
    try {
      const formData = new FormData();
      editSelectedFiles.forEach(({ file }) => {
        formData.append("comment_file", file);
      });

      const response = await axios.post(
        `${base_url.api1}/tourapp/claim-file`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // console.log("Files uploaded successfully:", response.data);
      // alert("Files uploaded successfully!");

      const filePaths = response.data.data.map((file) => file.comment_file);
      return filePaths;
      // } else {
      //   alert("No files selected.");
      // }
    } catch (error) {
      console.error("Error uploading files:", error);
      // alert("An error occurred while uploading files.");
    }
  };

  const [editSelectedFiles, setEditSelectedFiles] = useState([]);

  const handleEditNoteSelectedFiles = async (event) => {
    const files = Array.from(event.target.files);
    if (files.length > 0) {
      setEditSelectedFiles((prevFiles) => [
        ...prevFiles,
        ...files.map((file) => ({ file })),
      ]);
      console.log(`Stored ${files.length} files`);
    }
  };

  console.log("edit selected files", editSelectedFiles);

  const openEditFilePicker = (type) => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = type === "image" ? "image/*" : "*/*";
    input.multiple = true;
    input.onchange = (e) => {
      console.log("edit picker File selected:", e.target.files);
      handleEditNoteSelectedFiles(e);
    };
    input.click();
  };

  function getShortenedFileName(filePath) {
    if (!filePath) return "No File";
    const fileName = filePath.split("/").pop();
    const shortenedName =
      fileName.length > 15 ? `${fileName.slice(0, 15)}...` : fileName;
    return shortenedName;
  }

  function getShortenedFileNameForTravelers(filePath) {
    if (!filePath) return "No File";
    const fileName = filePath.split("/").pop();
    const shortenedName =
      fileName.length > 15 ? `${fileName.slice(0, 15)}...` : fileName;
    return shortenedName;
  }

  const [noteEditFieldOpen, setNoteEditFieldOpen] = useState(null);

  // delete user note function -----------------------------

  const userNoteDelete = async (index) => {
    const updatedNotes = previousNote.filter((note, i) => i !== index);

    const formData = new FormData();

    const formObject = {
      note: updatedNotes,
      from_customer: true,
    };
    const jsonFormObject = JSON.stringify(formObject);

    formData.append("data", jsonFormObject);

    const sendMessageUrl = `${base_url.api1}/tourapp/compensation_request?id=${params.claim_id}`;
    setbackdropopen(true);
    await axios
      .put(sendMessageUrl, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Origin: "https://flyandclaim.odisoft.in",
        },
      })
      .then((response) => {
        // setUserNote("");
        // setSelectedFiles([]);
        // alert("message deleted successfullly")
        getClaimDetails();
        setbackdropopen(false);
        // setUserNoteLoading(false);
      })
      .catch((error) => {
        setUserNote("");
        setbackdropopen(false);
        console.error("Error deleting message:", error);
        // setUserNoteLoading(false);
      });
  };

  const [editUserNote, setEditUserNote] = useState("");
  const handleUserEditNoteInputChange = (e) => {
    setEditUserNote(e.target.value);
  };

  const editCustomerNote = (notes, customerNote, newFilePaths, index) => {
    const dateTime = getCurrentDateTime();

    const previousFilePaths = notes[index]?.files || [];
    const combinedFilePaths = [...previousFilePaths, ...newFilePaths];

    const updatedNotes = [...notes];

    updatedNotes[index] = {
      ...updatedNotes[index],
      note: customerNote,
      edited: dateTime,
      files: combinedFilePaths,
    };

    return updatedNotes;
  };

  const userNoteEditSubmit = async (e, index) => {
    e.preventDefault();
    const trimmedNote = editUserNote.trim();
    if (trimmedNote === "") {
      return;
    }

    let newFilePaths = [];
    if (editSelectedFiles.length > 0) {
      newFilePaths = await handleEditNoteFileUpload();
    }
    const updatedNotes = editCustomerNote(
      previousNote,
      editUserNote,
      newFilePaths,
      index
    );

    const formData = new FormData();

    const formObject = {
      note: updatedNotes,
      from_customer: true,
    };
    const jsonFormObject = JSON.stringify(formObject);

    formData.append("data", jsonFormObject);

    const sendMessageUrl = `${base_url.api1}/tourapp/compensation_request?id=${params.claim_id}`;
    setbackdropopen(true);
    await axios
      .put(sendMessageUrl, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Origin: "https://flyandclaim.odisoft.in",
        },
      })
      .then((response) => {
        setbackdropopen(false);
        setEditUserNote("");
        setEditSelectedFiles([]);
        setNoteEditFieldOpen(null);
        getClaimDetails();
        // alert("Message Edited successfully");
      })
      .catch((error) => {
        setUserNote("");
        setbackdropopen(false);
        console.error("Error sending message:", error);
      });
  };



  // customer care start note


    // add user note final click function
  const handleCustomerUserNoteSubmit = async (e) => {
    e.preventDefault();
    const trimmedNote = customerUserNote.trim();
    if (trimmedNote === "" && customerSelectedFiles.length === 0) {
      return;
    }

      setbackdropopen(true);
    // setUserNoteLoading(true);
    let filePaths = [];
    if (customerSelectedFiles.length > 0) {
      filePaths = await handleCustomerNoteFileUpload();
    }
    const updatedNotes = addCustomerCareNote(customerCareNote, customerUserNote, filePaths);

    const formData = new FormData();

    const formObject = {
      customer_care_note: updatedNotes,
      from_customer: true,
    };
    const jsonFormObject = JSON.stringify(formObject);

    formData.append("data", jsonFormObject);

    const sendMessageUrl = `${base_url.api1}/tourapp/compensation_request?id=${params.claim_id}`; // Replace with your actual URL
  
    await axios
      .put(sendMessageUrl, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Origin: "https://flyandclaim.odisoft.in",
        },
      })
      .then((response) => {
        setCustomerUserNote("");
        setCustomerSelectedFiles([]);
        getClaimDetails();
        setbackdropopen(false);
      })
      .catch((error) => {
        setCustomerUserNote("");
        console.error("Error sending message:", error);
        setbackdropopen(false);
      });
  };

  // add file upload
  const handleCustomerNoteFileUpload = async () => {
    if (customerSelectedFiles.length === 0) {
      // alert("No files selected to upload");
      return;
    }
    try {
      const formData = new FormData();
      customerSelectedFiles.forEach(({ file }) => {
        formData.append("comment_file", file);
      });

      const response = await axios.post(
       `${base_url.api1}/tourapp/claim-file`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log("Files uploaded successfully:", response.data);
      // alert("Files uploaded successfully!");

      const filePaths = response.data.data.map((file) => file.comment_file);
      return filePaths;
      // } else {
      //   alert("No files selected.");
      // }
    } catch (error) {
      console.error("Error uploading files:", error);
      setbackdropopen(false);
      // alert("An error occurred while uploading files.");
    }
  };

  const [customerSelectedFiles, setCustomerSelectedFiles] = useState([]);

  const handleCustomerNoteSelectedFiles = async (event) => {
    const files = Array.from(event.target.files);
    if (files.length > 0) {
      setCustomerSelectedFiles((prevFiles) => [
        ...prevFiles,
        ...files.map((file) => ({ file })),
      ]);
      console.log(`Stored ${files.length} files`);
    }
  };

  // console.log(selectedFiles);

  const openCustomerFilePicker = (type) => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = type === "image" ? "image/*" : "*/*";
    input.multiple = true;
    input.onchange = (e) => {
      console.log("File selected:", e.target.files);
      handleCustomerNoteSelectedFiles(e);
    };
    input.click();
  };

  // edit note file upload
  const handleEditCustomerNoteFileUpload = async () => {
    if (editSelectedCustomerFiles.length === 0) {
      // alert("No files selected to upload");
      return;
    }
    try {
      const formData = new FormData();
      editSelectedCustomerFiles.forEach(({ file }) => {
        formData.append("comment_file", file);
      });

      const response = await axios.post(
        `${base_url.api1}/tourapp/claim-file`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // console.log("Files uploaded successfully:", response.data);
      // alert("Files uploaded successfully!");

      const filePaths = response.data.data.map((file) => file.comment_file);
      return filePaths;
      // } else {
      //   alert("No files selected.");
      // }
    } catch (error) {
      console.error("Error uploading files:", error);
      // alert("An error occurred while uploading files.");
    }
  };

  const [editSelectedCustomerFiles, setEditSelectedCustomerFiles] = useState([]);

  const handleCustomerEditNoteSelectedFiles = async (event) => {
    const files = Array.from(event.target.files);
    if (files.length > 0) {
      setEditSelectedCustomerFiles((prevFiles) => [
        ...prevFiles,
        ...files.map((file) => ({ file })),
      ]);
      console.log(`Stored ${files.length} files`);
    }
  };

  console.log("edit selected files", editSelectedFiles);

  const openEditCutomerFilePicker = (type) => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = type === "image" ? "image/*" : "*/*";
    input.multiple = true;
    input.onchange = (e) => {
      console.log("edit picker File selected:", e.target.files);
      handleCustomerEditNoteSelectedFiles(e);
    };
    input.click();
  };

  function getShortenedCustomerFileName(filePath) {
    if (!filePath) return "No File";
    const fileName = filePath.split("/").pop();
    const shortenedName =
      fileName.length > 15 ? `${fileName.slice(0, 15)}...` : fileName;
    return shortenedName;
  }

  function getShortenedCustomerFileNameForTravelers(filePath) {
    if (!filePath) return "No File";
    const fileName = filePath.split("/").pop();
    const shortenedName =
      fileName.length > 15 ? `${fileName.slice(0, 15)}...` : fileName;
    return shortenedName;
  }

  const [customerNoteEditFieldOpen, setCustomerNoteEditFieldOpen] = useState(null);

  // delete user note function -----------------------------

  const customerUserNoteDelete = async (index) => {
    const updatedNotes = customerCareNote.filter((note, i) => i !== index);

    const formData = new FormData();

    const formObject = {
      customer_care_note: updatedNotes,
      from_customer: true,
    };
    const jsonFormObject = JSON.stringify(formObject);

    formData.append("data", jsonFormObject);

    const sendMessageUrl = `${base_url.api1}/tourapp/compensation_request?id=${params.claim_id}`;
    setbackdropopen(true);
    await axios
      .put(sendMessageUrl, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Origin: "https://flyandclaim.odisoft.in",
        },
      })
      .then((response) => {
        // setUserNote("");
        // setSelectedFiles([]);
        // alert("message deleted successfullly")
        getClaimDetails();
        setbackdropopen(false);
        // setUserNoteLoading(false);
      })
      .catch((error) => {
        setCustomerUserNote("");
        setbackdropopen(false);
        console.error("Error deleting message:", error);
        // setUserNoteLoading(false);
      });
  };

  const [editCustomerUserNote, setEditCustomerUserNote] = useState("");
  const handleCustomerUserEditNoteInputChange = (e) => {
    setEditCustomerUserNote(e.target.value);
  };

  const editCustomerCareNote = (notes, customerNote, newFilePaths, index) => {
    const dateTime = getCurrentDateTime();

    const previousFilePaths = notes[index]?.files || [];
    const combinedFilePaths = [...previousFilePaths, ...newFilePaths];

    const updatedNotes = [...notes];

    updatedNotes[index] = {
      ...updatedNotes[index],
      note: customerNote,
      edited: dateTime,
      files: combinedFilePaths,
    };

    return updatedNotes;
  };

  const customerUserNoteEditSubmit = async (e, index) => {
    e.preventDefault();
    const trimmedNote = editCustomerUserNote.trim();
    if (trimmedNote === "") {
      return;
    }

    let newFilePaths = [];
    if (editSelectedCustomerFiles.length > 0) {
      newFilePaths = await handleEditCustomerNoteFileUpload();
    }
    const updatedNotes = editCustomerCareNote(
      customerCareNote,
      editCustomerUserNote,
      newFilePaths,
      index
    );

    const formData = new FormData();

    const formObject = {
      customer_care_note: updatedNotes,
      from_customer: true,
    };
    const jsonFormObject = JSON.stringify(formObject);

    formData.append("data", jsonFormObject);

    const sendMessageUrl = `${base_url.api1}/tourapp/compensation_request?id=${params.claim_id}`;
    setbackdropopen(true);
    await axios
      .put(sendMessageUrl, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Origin: "https://flyandclaim.odisoft.in",
        },
      })
      .then((response) => {
        setbackdropopen(false);
        setEditCustomerUserNote("");
        setEditSelectedCustomerFiles([]);
        setCustomerNoteEditFieldOpen(null);
        getClaimDetails();
        // alert("Message Edited successfully");
      })
      .catch((error) => {
        setCustomerCareNote("");
        setbackdropopen(false);
        console.error("Error sending message:", error);
      });
  };

  











  const handleUploadAddionalFiles = () => {
    if (addtionalFiles.length == 0) {
      return;
    }

    const formData = new FormData();

    const id = JSON.stringify({
      claim_id: params.claim_id,
      from_customer: true,
    });

    formData.append("data", id);
    addtionalFiles.forEach((file) => {
      formData.append("document", file);
    });

    axios.post(`${base_url.api1}/tourapp/claim_doc`, formData).then(
      (response) => {
        setbackdropopen(false);

        setAdditionalFiles([]);
        setUpdating((prev) => !prev);
        console.log("Success");
      },
      (error) => {
        setbackdropopen(false);
        // toast.error(JSON.stringify(error.message));
      }
    );
  };

  const [updatedAddionalClaims, setUpdatedAddtionalClaims] = useState([]);

  const triggerFileInput = (index) => {
    if (otherClaimFilesRef.current[index]) {
      otherClaimFilesRef.current[index].click();
    }
  };
  const triggerSubClaimFileInput = (index, type) => {
    if (
      subClaimFilesRef.current[index] &&
      subClaimFilesRef.current[index][type]
    ) {
      subClaimFilesRef.current[index][type].click();
    }
  };

  const [updatedSubClaim, setUpdatedSubClaim] = useState([]);
  const handleSubClaimFileChange = (e, index, type) => {
    const file = e.target.files?.[0];
    if (!file) return;

    // Update familyMembers state
    const updatedFamily = [...familyMembers];
    updatedFamily[index] = {
      ...updatedFamily[index],
      [type]: null,
      [`update_${type}`]: file,
    };
    setFamilyMembers(updatedFamily);

    const nameKey = `sub_claim_${type}${index + 1}`;
    const updatedFileEntry = {
      name: nameKey,
      file: file,
      type: type,
    };

    const updatedMember = {
      id: updatedFamily[index].id,
      file: [updatedFileEntry],
    };

    // Update updatedSubClaim state: replace if id already exists, else add
    setUpdatedSubClaim((prev) => {
      const filtered = prev.filter((item) => item.id !== updatedMember.id);

      const existing = prev.find((item) => item.id === updatedMember.id);
      if (existing) {
        // Merge file types for the same user
        const existingFiles = [...existing.file];
        const existingIndex = existingFiles.findIndex((f) => f.type === type);

        if (existingIndex !== -1) {
          existingFiles[existingIndex] = updatedFileEntry;
        } else {
          existingFiles.push(updatedFileEntry);
        }

        return [...filtered, { id: updatedMember.id, file: existingFiles }];
      } else {
        return [...filtered, updatedMember];
      }
    });
  };

  console.log("Updated Sub Claims ===========> ", updatedSubClaim);
  console.log("Family Member ===========> ", familyMembers);

  const handleUpdatedClaimFileChange = (e, index) => {
    const file = e.target.files?.[0];
    if (!file) return;

    // Update additionalClaimDetails
    const updatedClaims = [...additionalClaimDetails];
    updatedClaims[index] = {
      ...updatedClaims[index],
      other_claim_doc: null,
      other_claim_updated_doc: file,
    };
    setAdditionalClaimDetails(updatedClaims);

    // Prepare the new updated claim object
    const updatedClaim = {
      id: updatedClaims[index].id,
      other_claim_doc: `other_claim_doc${index + 1}`,
      file,
    };

    // Update updatedAddtionalClaims by replacing or adding the claim
    setUpdatedAddtionalClaims((prev) => {
      const filtered = prev.filter((item) => item.id !== updatedClaim.id);
      return [...filtered, updatedClaim];
    });
  };

  console.log("Updated Addional Claims =======> ", updatedAddionalClaims);

  const handleUpdateClaim = async () => {
    // if (addtionalFiles.length > 0) {
    //   handleUploadAddionalFiles();
    // }

    if (
      Object.keys(claimFiles).length > 0 ||
      updatedAddionalClaims.length > 0 ||
      updatedSubClaim.length > 0 || addtionalFiles.length > 0
    ) {
      handleUploadDetails();
    }
  };

  function checkMissingPassports(familyMembers, updatedSubClaim) {
    // Step 1: find missing passport IDs
    const missingPassportIds = familyMembers
      .filter((member) => member.passport === null)
      .map((member) => member.id);

    // Step 2: if no missing passports → true
    if (missingPassportIds.length === 0) return true;

    // Step 3: check if all missing passports are covered in updatedSubClaim
    return (
      updatedSubClaim.length > 0 &&
      missingPassportIds.every((id) => {
        const claim = updatedSubClaim.find((c) => c.id === id);
        return claim && claim.file.some((f) => f.type === "passport");
      })
    );
  }


 
   const updateTimeline = async() => {
    
     let timelineObject = {
      status: "Updated",
          notes: "Claim request documents has been updated.",
       timestamp: moment().format("h:mm A MMMM D, YYYY"),
      claim_id: params.claim_id,
    
    };
      const sendTimelineUrl = `${base_url.api1}/tourapp/claim_log`; // Replace with your actual URL
  
      axios
        .post(sendTimelineUrl, timelineObject, {})
        .then((response) => {
           console.log(response)
        })
        .catch((error) => {
         console.log(error)
        });
    };

  const handleUploadDetails = (skipFileCheck=false) => {
    const formData = new FormData();
    let data = {
      id: params.claim_id,
      from_customer: true,

    };

    if (skipFileCheck) {
      data.document_note= documentNote
      
    }

    console.log("Claim Files in Upload ===========> ", claimFiles);
console.log(familyMembers)
    console.log(updatedSubClaim)

   const hasFileChanges =
  Object.keys(claimFiles || {}).length > 0 ||
      updatedSubClaim?.length > 0 
    
  if (!skipFileCheck && hasFileChanges) {
      setDocumentNoteOpened(true);
      return;
    }
 
    // if (Object.keys(claimFiles).length > 0) {
    //   Object.entries(claimFiles).forEach(([key, file]) => {
    //     if (file) {
    //       formData.append(key, file);
    //     }
    //   });
    // }
    if (powerOfAttorneyFile) {
      formData.append("power_of_attorney", powerOfAttorneyFile);
    }
    console.log(claimFiles);
    if (claimFiles && Object.keys(claimFiles).length > 0) {
      Object.entries(claimFiles).forEach(([key, file]) => {
        if (file instanceof Blob || file instanceof File) {
          formData.append(key, file, file.name || "key.pdf");
        } else {
          console.warn(`Skipping ${key}: Not a file`);
        }
      });
    }



    if (updatedAddionalClaims.length > 0) {
      const additionalClaimDataPayload = updatedAddionalClaims.map(
        (claim, index) => {
          const claimData = {
            id: claim.id,
            other_claim_doc: claim.other_claim_doc,
          };

          if (claim.file) {
            formData.append(claim.other_claim_doc, claim.file);
          }

          return claimData;
        }
      );

      data["other_claims"] = additionalClaimDataPayload;
    }

    console.log(updatedSubClaim);
    if (updatedSubClaim.length > 0) {
      const subClaimPayload = updatedSubClaim.map((item) => {
        const transformed = { id: item.id };

        item.file.forEach((doc) => {
          transformed[doc.type] = doc.name;
        });

        return transformed;
      });

      updatedSubClaim.forEach((item) => {
        item.file.forEach((doc) => {
          formData.append(doc.name, doc.file);
        });
      });

      data["sub_claims"] = subClaimPayload;
    }

    const hasUpdatedPassport = "passport" in claimFiles;

    // const allExistingSubClaimPassport = familyMembers.every(
    //   (member) => member.hasOwnProperty("passport") && member.passport !== null
    // );

    console.log(familyMembers);
    // if (familyMembers.length > 0) {
      // const allExistingSubClaimPassport = familyMembers.every(
      //   (member) =>
      //     member.hasOwnProperty("passport") && member.passport !== null
      // );

      // const allSubClaimUpdatedPassport =
      //   updatedSubClaim.length > 0 &&
      //   updatedSubClaim.every((claim) =>
      //     claim.file.every((f) => f.type === "passport")
      //   );

      //upper one old


      // pending and incomplete status

    //   const allHavePassports = checkMissingPassports(
    //     familyMembers,
    //     updatedSubClaim
    //   );

    //   if (
    //     (powerPdf || powerOfAttorneyFile) &&
    //     (passportImg || hasUpdatedPassport) &&
    //     allHavePassports
    //   ) {
    //     data.status = "pending";
    //   } else {
    //     data.status = "incomplete";
    //   }
    // } else {
    //   if (hasUpdatedPassport || passportImg) {
    //     data.status = "pending";
    //   } else {
    //     data.status = "incomplete";
    //   }
    // }



    console.log(Array.from(formData.entries()));
    formData.append("data", JSON.stringify(data));
    if (addtionalFiles.length > 0) {
    addtionalFiles.forEach((file) => {
      formData.append("document", file);
    });
}
   
    setbackdropopen(true);

    axios
      .put(
        `${base_url.api1}/tourapp/compensation_request?id=${claim_id}`,
        formData
        // {
        //   headers: {
        //     Authorization: jwtToken,
        //   },
        // }
      )
      .then(
       async (response) => {
          // toast.success("Success");
          await updateTimeline();
          setbackdropopen(false);
          setAdditionalFiles([])
         
          setDocumentNote('');

          setUpdating((prev) => !prev);
          setClaimFiles({});
          setUpdatedAddtionalClaims([]);
          setUpdatedSubClaim([]);
          setWesignUrl(null);
          setPowerOfAttorneyFile(null);
          setRecipientEmail(null);
          setSignEnvolpeId(null);
          window.scrollTo(0, 0);
          Swal.fire({
            icon: "success",
            title: "Success",
            text: `Claim Updated successfully.`,
          });
          console.log("Success");
        },
        (error) => {
          window.scrollTo(0, 0);

          setbackdropopen(false);
          Swal.fire({
            icon: "error",
            title: "Error",
            text: `Failed to update claim.`,
          });
          // toast.error(JSON.stringify(error.message));
        }
      );
  };

  const [openClaimDeleteModal, setOpenClaimDeleteModal] = useState(false);

  const handleDeleteModalOpen = () => {
    setOpenClaimDeleteModal(true);
  };

  const closeClaimDeleteModal = () => {
    setOpenClaimDeleteModal(false);
  };
  const [updatedImageViewModal, setUpdatedImageViewModal] = useState(false);
  const [updatedImgUrl, setUpdatedImgUrl] = useState(null);
  const [fileType, setFileType] = useState("");
  const [updatedBoardingPass, setUpdatedBoardingPass] = useState(null);

  const [claimFiles, setClaimFiles] = useState({});
  const [addtionalFiles, setAdditionalFiles] = useState([]);
  const [otherClaimsFiles, setOtherClaimFiles] = useState({});

  const handleUpdatedAddionalFileChange = (e) => {
    const files = e.target.files;
    if (files) {
      let addtionalfilesArray = Array.from(files);
      setAdditionalFiles(addtionalfilesArray);
    }
  };

  const handleUpdatedFileChange = (e, type) => {
    const file = e.target.files;
    if (file) {
      setClaimFiles((prevFiles) => ({
        ...prevFiles,
        [type]: file[0],
      }));

      if (type == "boarding_pass") {
        setBoardingImg(null);
      }

      if (type == "passport") {
        setPassportImg(null);
      }
    }
  };

  console.log("Claim Files ==========> ", claimFiles);

  const truncateText = (file) => {
    if (!file) {
      return false;
    }

    const tempFile = file?.split("/").pop();

    const filename =
      tempFile.length > 22 ? tempFile.slice(0, 22) + "..." : tempFile;

    return filename;
  };

  const getShortUpdatedFilename = (file, lengthOfText = 15) => {
    if (!file) {
      return;
    }

    const filename =
      file.name.length > lengthOfText
        ? file.name.slice(0, lengthOfText) + "..."
        : file.name;

    return filename;
  };

  const handleViewUpdatedFile = (file) => {
    if (!file) {
      return;
    }

    const previewUrl = URL.createObjectURL(file);
    setUpdatedImgUrl(previewUrl);
    if (file.type == "application/pdf") {
      window.open(previewUrl, "_blank");

      return;
    }
    setFileType(file.type);
    setUpdatedImageViewModal(true);
  };

  console.log("Updated Files ================ > ", updatedBoardingPass);
  const handleDeleteClaim = () => {
    const deleteClaimUrl = `${base_url.api1}/tourapp/compensation_request?id=${params.claim_id}`;
    setbackdropopen(true);
    axios
      .delete(deleteClaimUrl)
      .then((response) => {
        setbackdropopen(false);
        setOpenClaimDeleteModal(false);
        Swal.fire({
          icon: "success",
          title: "Success",
          text: `Claim deleted successfully.`,
        }).then(() => {
          navigate("/dashboard", { replace: true });
        });
      })
      .catch((error) => {
        setbackdropopen(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: `Failed to delete claim.`,
        });
      });
  };

  const navigate = useNavigate();

  const fetchSignedDocument = async (envolpeId,envelopeRecipientEmail=recipientEmail) => {
    const sign_url = `${base_url.api1}/tourapp/wesign_signed_doc_new?id=${envolpeId}&email=${envelopeRecipientEmail}`;
    const response = await axios.get(sign_url);

    if (response?.data && response?.data?.status_code === 200) {
      await updateSignerStatus(envelopeRecipientEmail, params.claim_id)
    }
    if (response.data?.Document) {
      const document_url = response.data.Document;
      const pdfResponse = await fetch(document_url);
      if (!pdfResponse.ok) throw new Error("Failed to fetch the document.");
      const genPdfBlob = await pdfResponse.blob();
      return genPdfBlob;
    } else {
      throw new Error("Signed document not found.");
    }
  };

  const updateSignerStatus = async (email, claim_id) => {
    const response = await axios.post(
      `${base_url.api1}/tourapp/compensation/signers`,
      {
        recipient: email,
        claim_id: claim_id,
      }
    );
    return response.data; // Return response if needed
  };

  const [isWesignModalOpen, setIsWesignModalOpen] = useState(false);
  const [wesignUrl, setWesignUrl] = useState(null);
  const [recipientEmail, setRecipientEmail] = useState(null);
  const [signEnvolpeId, setSignEnvolpeId] = useState(null);
  const [powerOfAttorneyFile, setPowerOfAttorneyFile] = useState(null);
const [newAgreementBlob,setNewAgreementBlob]=useState(null)
  
  const handleClose = async () => {
    setIsWesignModalOpen(false);

    try {
      setbackdropopen(true);

      const [genPdfBlob] = await Promise.all([
        fetchSignedDocument(signEnvolpeId),
       
      ]);

      if (genPdfBlob) {
        const poaFile = new File([genPdfBlob], "power_of_attorney_dd.pdf", {
          type: genPdfBlob.type,
        });

        setPowerOfAttorneyFile(poaFile);
      }

      // setSignatureCaptured(true);
      // setDocumentFetched(true);
      // console.log("Signer status response:", signerStatus);
    } catch (error) {
      console.error("Error during parallel execution:", error);
    } finally {
      setbackdropopen(false);
    }
  };

  // useEffect(() => {
  //   if (newAgreementBlob) {
      
  //     submitNewAgreement(newAgreementBlob)
  //   }
  // },[newAgreementBlob])

  const submitNewAgreement = async(newAgreementFile) => {
    
    console.log(newAgreementFile)
    const formData = new FormData();
   
    const formObject = {
     
      agreement_signed:true
     
    };

    
    const jsonFormObject = JSON.stringify(formObject);

     if (newAgreementFile) {
      const pdfFile = new File([newAgreementFile], "agreement.pdf", {
        type: "application/pdf",
      });
     

      formData.append("agreement", pdfFile);
    }
   
  
   
    formData.append("data", jsonFormObject);

   

    setbackdropopen(true);
   

 
   await axios
      .put(
        `${base_url.api1}/tourapp/compensation_request?id=${claim_id}`,
        formData,
        {
          headers: {
            Origin: "https://flyandclaim.odisoft.in",
          },
        }
      )
      .then(
        () => {
          setbackdropopen(false);
          setAgreementModalOpen(false)
          Swal.fire({
            icon: "success",
            title: "Success",
            text: `Agreement Updated successfully.`,
          }).then(() => {
            window.location.reload();
          });
        },
        () => {
          setbackdropopen(false);
        }
      );
  };

  


  const [showContinueBtn,setShowContinueBtn]=useState(false)
  
    useEffect(() => {
      const onMessage = (event) => {
        if (event.data?.type === "IFRAME_URL_CHANGED") {
          console.log("Iframe URL changed to:", event.data.url);
          // Do whatever you need here
          if (event.data.url.includes("postsigning")) {
         setShowContinueBtn(true)
        }
        }
      };
  
      window.addEventListener("message", onMessage);
      return () => window.removeEventListener("message", onMessage);
    }, []);
  
  
      useEffect(() => {
      if (isAgreementModalOpen) {
        setShowContinueBtn(false);
      }
    }, [isAgreementModalOpen]);

     const fetchAgreementDocument = async () => {
       try {
         setbackdropopen(true);
         // const sign_url = `${base_url.api1}/tourapp/get_signed_doc?id=${envolpeId}`;
         const sign_url = `${base_url.api1}/tourapp/wesign_signed_doc_new?id=${claimData?.envelope_id}`;
   
         const response = await axios.get(sign_url);
   
         console.log(response)
        
         if (response.data && response.data.Document) {
           const document_url = response.data.Document;
   
           const pdfResponse = await fetch(document_url);
   
           if (!pdfResponse.ok) {
             throw new Error("Failed to fetch the document.");
           }
   
           const pdfBlob = await pdfResponse.blob();
   
           console.log(pdfBlob)
          //  setNewAgreementBlob(pdfBlob);

           await submitNewAgreement(pdfBlob)




           
   
         } else {
           console.error("Signed document is not present in the response.");
   
   
         }
       } catch (error) {
         console.error("Error fetching signed document:", error);
   
   
       } finally {
         //console.log("Completed fetching the document.");
         setbackdropopen(false);
   
   
       }
     };
   
     const handleAgreementClose = () => {
       fetchAgreementDocument();
     };

  useEffect(() => {
    if (powerOfAttorneyFile !== null) {
      handleUploadDetails();
    }
  }, [powerOfAttorneyFile]);

  console.log("After POA Upload Claim Files ===========> ", claimFiles);
  const handleSignerClick = (signer) => {
    console.log("Clicked Signer:", signer);
    setWesignUrl(signer.sign_url);
    setRecipientEmail(signer.email);
    setSignEnvolpeId(signer.envelope_id);
    setIsWesignModalOpen(true);
    // setbackdropopen(true);
  };


  const handleCheckStatus=async(signer) => {
   
      try {
      setbackdropopen(true);

      const [genPdfBlob] = await Promise.all([
        fetchSignedDocument(signer.envelope_id,signer.email),
       
      ]);

      if (genPdfBlob) {
        const poaFile = new File([genPdfBlob], "power_of_attorney_dd.pdf", {
          type: genPdfBlob.type,
        });

        setPowerOfAttorneyFile(poaFile);
      }

      // setSignatureCaptured(true);
      // setDocumentFetched(true);
      // console.log("Signer status response:", signerStatus);
    } catch (error) {
      console.error("Error during parallel execution:", error);
    } finally {
      setbackdropopen(false);
    }
  }
  const handleCopyLink = (signer) => {
    const link = signer.sign_url;
    navigator.clipboard
      .writeText(link)
      .then(() => {
        Swal.fire({
          icon: "success",
          title: "Link Copied",
          text: `The signing link has been copied to your clipboard.`,
        });
      })
      .catch((error) => {
        console.error("Failed to copy link:", error);
        Swal.fire({
          icon: "error",
          title: "Copy Failed",
          text: `Failed to copy the signing link.`,
        });
      });
  };

  const handleLoad = () => {
    setbackdropopen(false);
  };

  return (
    <div className="indivisual-claim">
      <Modal
        opened={isWesignModalOpen}
        onClose={() => setIsWesignModalOpen(false)}
        size={window.innerWidth < 768 ? "100%" : "95%"}
        fullScreen={window.innerWidth < 768}
        // fullScreen={true}
        classNames={{
          content: "custom-content",
          body: "custom-body",
        }}
        // styles={{
        //   content: {
        //     height: '80vh !important',
        //     display: 'flex !important',
        //     flexDirection: 'column !important',
        //   },
        //   body: {
        //     flex: '1 !important',
        //     height:'calc(100% - 60px) !important',
        //     display: 'flex !important',
        //     flexDirection: 'column !important',

        //   },
        // }}
        // style={{
        //   content: {
        //     top: "50%",
        //     left: "50%",
        //     right: "auto",
        //     bottom: "auto",
        //     marginRight: "-50%",
        //     transform: "translate(-50%, -50%)",
        //     width: "90%",

        //     maxHeight: "125%",
        //     overflow: "auto",
        //     backgroundColor: "#f0f0f0",
        //     borderRadius: "8px",
        //     boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
        //   },
        //   overlay: {
        //     zIndex: 2000, // Ensure overlay is above the previous modal
        //     backgroundColor: "rgba(0, 0, 0, 0.75)",
        //   },
        // }}
      >
        {/* <div className="d-flex justify-content-end">
          <Button
            variant="contained"
            color="secondary"
            onClick={handleClose}
            style={{ marginBottom: "10px" }}
          >
            Close
          </Button>
        </div> */}
        {wesignUrl ? (
          <iframe
            src={wesignUrl}
            title="DocuSign"
            width="100%"
            height="100%"
            onLoad={handleLoad}
            style={{ border: "none" }}
          ></iframe>
        ) : (
          <p>Loading...</p>
        )}
        <div className="d-flex justify-content-end p-3 ">
          <Button onClick={handleClose} variant="contained" color="primary">
            Save
          </Button>
        </div>
      </Modal>


        <Modal
        opened={isAgreementModalOpen}
        onClose={() => setAgreementModalOpen(false)}
        // size={window.innerWidth < 768 ? "100%" : "95%"}
        // fullScreen={window.innerWidth < 768}
        fullScreen={true}
        classNames={{
          content: "custom-content",
          body: "custom-body",
        }}
       
      >

         {
          showContinueBtn &&  <div className="d-flex justify-content-end signature-modal-btn" >
          
          <button
            onClick={handleAgreementClose}
            className="signature-btn"
           
          >
            Please press to continue
          </button>
        </div>
        }
        
        {claimData?.agreement_url ? (
          <iframe
            src={claimData?.agreement_url}
            title="DocuSign"
            width="100%"
            height="100%"
            onLoad={handleLoad}
            style={{ border: "none" }}
          ></iframe>
        ) : (
          <p>Loading...</p>
        )}
      
      </Modal>

      <Modal
        opened={updatedImageViewModal}
        onClose={() => setUpdatedImageViewModal(false)}
        style={customStylesAttachment}
        contentLabel="Viexw File Modal"
      >
        <div style={{ textAlign: "right" }}>
          <EditCrossIcon
            style={{ cursor: "pointer" }}
            onClick={() => setUpdatedImageViewModal(false)}
          />
        </div>
        <div className="view-file-model-container">
          {updatedImgUrl && (
            <>
              {fileType.startsWith("image/") ? (
                <img
                  src={updatedImgUrl}
                  alt="Preview"
                  style={{ maxWidth: "300px", marginTop: "10px" }}
                />
              ) : fileType === "application/pdf" ? (
                <iframe
                  src={updatedImgUrl}
                  title="PDF Preview"
                  width="100%"
                  height="500px"
                  style={{ border: "1px solid #ccc", marginTop: "10px" }}
                />
              ) : (
                <p>Unsupported file type.</p>
              )}
            </>
          )}

          <div style={{ textAlign: "center" }}>
            <button
              className="view-file-model-button"
              onClick={() => setUpdatedImageViewModal(false)}
            >
              CLOSE
            </button>
          </div>
        </div>
      </Modal>

      <Modal
        opened={openClaimDeleteModal}
        onClose={closeClaimDeleteModal}
        centered
        radius={"lg"}
        size={"md"}
        withCloseButton={false}
      >
        <div
          style={{
            position: "relative",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "30px",
            padding: "30px",
          }}
        >
          {/* <CircleTickIcon /> */}
          <h5
            style={{ color: "#314064", fontSize: "24px", textAlign: "center" }}
          >
            Are you sure want to delete ?
          </h5>

          <div className="logout-btn-wrapper">
            <CustomButton
              style={{ width: "50%" }}
              btnText={"Cancel"}
              flex={1}
              onClick={closeClaimDeleteModal}
              type="secondary"
            />

            <CustomButton
              style={{ width: "50%" }}
              btnText={"Delete"}
              flex={1}
              onClick={handleDeleteClaim}
              type="danger"
            />
          </div>
        </div>
      </Modal>
      <Nav />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={backdropopen}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <div
        className="breadcrums-container"
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <ul className="breadcrums">
          <Link
            to="/dashboard"
            className="breadcrums-link"
            style={{ color: "#799DD2" }}
          >
            Dashboard
          </Link>
          <ChevronRight />
          <Link className="breadcrums-link" style={{ color: "#565A6D" }}>
            Claim #{claimData.contact_no} - {flightDetails[0]?.airline} -{" "}
            {moment(claimData.created_date).format("MM/DD/YYYY")}
          </Link>
        </ul>
      </div>
      <div className="dashboard-container">
        <div className="my-claim-wrapper">
          <div className="dashboard-header-container">
            <h4 className="dashboard-header">
              Claim #{claimData.unique_claim_id ||claimData.contact_no} - {flightDetails[0]?.airline} -{" "}
              {moment(claimData.created_date).format("MM/DD/YYYY")}
            </h4>
            <div className="indivisual-btn-wrapper">
              {/* <CustomButton btnText={"View Claim Details"} type="secondary" /> */}
              <div className="pdf-btn">
                <CustomButton btnText={"generate PDF"} onClick={handlePrint} />
                <iframe ref={iframeRef} style={{ display: "none" }} />
              </div>
            </div>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <h4 className="dashboard-header" style={{ marginBottom: 0 }}>
              Claim Details
            </h4>
            {/* <span
              className={`individual-claim-view-file-button`}
              onClick={() => {
                const step = user ? 7 : 6;
                localStorage.setItem("completedStep", step);
                navigate(`/edit-claim/${claim_id}`);
              }}
              style={{
                borderRadius: "4px",
                height: "100%",
                cursor: "pointer",
              }}
            >
              Edit
              <svg
                width="18px"
                height="18px"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  {" "}
                  <path
                    d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z"
                    stroke="#314064"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>{" "}
                  <path
                    d="M21 21H12"
                    stroke="#314064"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>{" "}
                </g>
              </svg>
            </span> */}
          </div>

          <div className="edit-claim-border">
            <div
              style={{
                // borderBottom: "1px solid #EFF3F9",
                padding: "0 0 20px 0",
              }}
            >
              <h6 className="claim-header-head">Claim details</h6>
              <div className="claim-data-wrapper">
                <div className="claim-data">
                  <label className="sub-header" style={{ color: "#222222" }}>
                    Submitted date
                  </label>
                  <span>
                    {claimData?.created_date
                      ? moment(claimData.created_date).format("MM/DD/YYYY")
                      : "No Data"}
                  </span>
                </div>

                <div className="claim-data">
                  <label className="sub-header" style={{ color: "#222222" }}>
                    Last update
                  </label>
                  <span>
                    {claimData?.updated_date
                      ? moment(claimData.updated_date).format("MM/DD/YYYY")
                      : "No Data"}
                  </span>
                </div>

                <div className="claim-data">
                  <label className="sub-header" style={{ color: "#222222" }}>
                    Claim type
                  </label>
                  <span style={{ textTransform: "capitalize" }}>
                    {claimData?.type_of_claim
                      ? claimData?.type_of_claim === "overbooking" ||
                        claimData?.type_of_claim === "denied_boarding"
                        ? "Denied Boarding"
                        : getClaimType(claimData?.type_of_claim)
                      : "No Data"}
                  </span>
                </div>

                <div className="claim-data">
                  <label className="sub-header" style={{ color: "#222222" }}>
                    Status
                  </label>
                  <span
                    style={{
                      textTransform: "capitalize",
                      borderRadius: "16px",
                      padding: "4px 16px",
                      width: "fit-content",
                      backgroundColor: getStatusStyles(claimData?.status)
                        .bgColor, // default
                      color: getStatusStyles(claimData?.status).color, // default
                    }}
                  >
                    {claimData?.status ?? "No Data"}
                  </span>
                </div>
              </div>
            </div>

            {/* <hr className="hr-line" /> */}
            <div
            // className="desktop-wrapper"
            // style={{
            //   // borderBottom: "1px solid #EFF3F9",
            //   padding: "20px 0",
            // }}
            >
              <h6 className="claim-header-head">Personal Details</h6>
              <div className="indivisual-section">
                <h6 className="claim-header">Traveler 1</h6>
                <div
                  className="claim-data-wrapper"
                  style={{ padding: "20px 0" }}
                >
                  <div className="claim-data">
                    <label className="sub-header" style={{ color: "#222222" }}>
                      Number of Passengers
                    </label>
                    <span>{claimData?.num_of_passenger ?? "No Data"}</span>
                  </div>
                  <div className="claim-data">
                    <label className="sub-header" style={{ color: "#222222" }}>
                      First Name
                    </label>
                    <span>{claimData?.first_name ?? "No Data"}</span>
                  </div>

                  <div className="claim-data">
                    <label className="sub-header" style={{ color: "#222222" }}>
                      Last Name
                    </label>
                    <span>{claimData?.last_name ?? "No Data"}</span>
                  </div>

                  <div className="claim-data">
                    <label className="sub-header" style={{ color: "#222222" }}>
                      Date Of Birth
                    </label>
                    <span>
                      {claimData?.date_of_birth
                        ? moment(claimData.date_of_birth).format("MM/DD/YYYY")
                        : "No Data"}
                    </span>
                  </div>
                </div>
                <div
                  className="claim-data-wrapper"
                  style={{ padding: "20px 0" }}
                >
                  <div className="claim-data">
                    <label className="sub-header" style={{ color: "#222222" }}>
                      Mobile Number
                    </label>
                    <span>{claimData?.contact_no ?? "No Data"}</span>
                  </div>

                  <div className="claim-data">
                    <label className="sub-header" style={{ color: "#222222" }}>
                      Email Address
                    </label>
                    <span>{claimData?.email_id ?? "No Data"}</span>
                  </div>
                  <div className="claim-data">
                    <label className="sub-header" style={{ color: "#222222" }}>
                      Passport Number
                    </label>
                    <span>{claimData?.passport_number ?? "No Data"}</span>
                  </div>

                  <div className="claim-data">
                    <label className="sub-header" style={{ color: "#222222" }}>
                      Home Address
                    </label>
                    <span>{claimData?.address ?? "No Data"}</span>
                  </div>
                </div>

                <div
                  className="claim-data-wrapper"
                  style={{ padding: "20px 0" }}
                >
                 <div className="claim-data">
                    <label className="sub-header" style={{ color: "#222222" }}>
                      Unit
                    </label>
                    <span>{claimData?.unit ?? "No Data"}</span>
                  </div>
                  <div className="claim-data">
                    <label className="sub-header" style={{ color: "#222222" }}>
                      City
                    </label>
                    <span>
                     {claimData?.city ?? "No Data"}
                     
                    </span>
                  </div>

                    <div className="claim-data">
                    <label className="sub-header" style={{ color: "#222222" }}>
                      State
                    </label>
                    <span>
                    
                      {claimData?.state ?? "No Data"}
                    </span>
                  </div>

                   <div className="claim-data">
                    <label className="sub-header" style={{ color: "#222222" }}>
                      Postal Code
                    </label>
                    <span>
                    
                      {claimData?.postal_code ?? "No Data"}
                    </span>
                  </div>

                  

                </div>

                <div
                  className="claim-data-wrapper"
                  style={{ padding: "20px 0" }}
                >

  <div className="claim-data">
                    <label className="sub-header" style={{ color: "#222222" }}>
                      Nationality
                    </label>
                    <span>
                    
                      {country1 ?? "No Data"}
                    </span>
                  </div>
                  
                  <div className="claim-data">
                    <label className="sub-header" style={{ color: "#222222" }}>
                      {/* 13 digit ticket Number */}
                      Ticket Number
                    </label>
                    <span>{claimData?.tickets ?? "No Data"}</span>
                  </div>

                  <div className="claim-data">
                    <label className="sub-header" style={{ color: "#222222" }}>
                      Airline Reservation Number
                    </label>
                    {/* <span>{claimData.airline_res_no}</span> */}
                    <span>{claimData?.airline_res_no ?? "No Data"}</span>
                  </div>

                  <div className="claim-data mobile-view-claim-data">
                    <div
                      className="d-flex align-items-center"
                      style={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <label
                        className="sub-header"
                        style={{ color: "#222222" }}
                      >
                        Boarding Pass
                      </label>
                      {/* add boardinging here if want to revert to previous design */}
                    </div>
                    <div className="file-wrapper">
                      {boardingImg ? (
                        <button
                          className={`individual-claim-view-file-button`}
                          style={{
                            ...(boardingImg ? {} : { cursor: "not-allowed" }),
                          }}
                          onClick={() => handleViewFile(boardingImg)}
                          disabled={!boardingImg}
                          type="button"
                        >
                          {/* {boardingImg ? "View File" : "No File"} */}
                          <DocumentIcon />
                          {boardingImg
                            ? getShortenedFileName(boardingImg)
                            : "No File"}
                        </button>
                      ) : claimFiles.boarding_pass ? (
                        <button
                          className={`individual-claim-view-file-button`}
                          onClick={() =>
                            handleViewUpdatedFile(claimFiles.boarding_pass)
                          }
                          type="button"
                        >
                          {/* {boardingImg ? "View File" : "No File"} */}
                          <DocumentIcon />
                          {claimFiles.boarding_pass
                            ? getShortUpdatedFilename(claimFiles.boarding_pass)
                            : "No File"}
                        </button>
                      ) : (
                        <p>No Document Added</p>
                      )}

                      <input
                        style={{ display: "none" }}
                        ref={boardingPassRef}
                        onChange={(e) =>
                          handleUpdatedFileChange(e, "boarding_pass")
                        }
                        type="file"
                        className="form-control mt-2"
                        name="boarding_pass"
                      />
                          <Tooltip label="Edit File">

                      <span
                        onClick={() => boardingPassRef.current.click()}
                        className={`individual-claim-view-file-button`}
                        style={{
                          borderRadius: "4px",
                          height: "100%",
                          cursor: "pointer",
                        }}
                      >
                        <svg
                          width="18px"
                          height="18px"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                          <g
                            id="SVGRepo_tracerCarrier"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></g>
                          <g id="SVGRepo_iconCarrier">
                            {" "}
                            <path
                              d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z"
                              stroke="#314064"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></path>{" "}
                            <path
                              d="M21 21H12"
                              stroke="#314064"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></path>{" "}
                          </g>
                        </svg>
                        </span>
                        </Tooltip>
                    </div>

                    {/* <span>
                    {" "}
                    <div>
                      <input
                        placeholder="Select your file"
                        type="file"
                        className="form-control claim-detail-input"
                        {...register("boarding_pass", {
                          required: false,
                        })}
                        disabled={true}
                      />
                    </div>
                  </span> */}
                  </div>
                 
                </div>

                  <div
                  className="claim-data-wrapper"
                  style={{ padding: "20px 0" }}
                >

                  
                   <div className="claim-data mobile-view-claim-data">
                    <div
                      className="d-flex align-items-center"
                      style={{ justifyContent: "space-between" }}
                    >
                      <label
                        className="sub-header"
                        style={{ color: "#222222" }}
                      >
                        Passport
                      </label>
                    </div>

                    <div className="file-wrapper">
                      {passportImg ? (
                        <button
                          className={`individual-claim-view-file-button`}
                          style={{
                            ...(passportImg ? {} : { cursor: "not-allowed" }),
                          }}
                          onClick={() => handleViewFile(passportImg)}
                          disabled={!passportImg}
                          type="button"
                        >
                          {/* {passportImg ? "View File" : "No File"} */}
                          <DocumentIcon />
                          {passportImg
                            ? getShortenedFileName(passportImg)
                            : "No File"}
                        </button>
                      ) : claimFiles.passport ? (
                        <button
                          className={`individual-claim-view-file-button`}
                          onClick={() =>
                            handleViewUpdatedFile(claimFiles.passport)
                          }
                          type="button"
                        >
                          {/* {boardingImg ? "View File" : "No File"} */}
                          <DocumentIcon />
                          {claimFiles.passport
                            ? getShortUpdatedFilename(claimFiles.passport)
                            : "No File"}
                        </button>
                      ) : (
                        <p>No Document Added</p>
                      )}

                      <input
                        style={{ display: "none" }}
                        ref={passportRef}
                        onChange={(e) => handleUpdatedFileChange(e, "passport")}
                        type="file"
                        className="form-control mt-2"
                        name="passport"
                      />
                       <Tooltip label="Edit File">
                      <span
                        onClick={() => passportRef.current.click()}
                        className={`individual-claim-view-file-button`}
                        style={{
                          borderRadius: "4px",
                          height: "100%",
                          cursor: "pointer",
                        }}
                      >
                        <svg
                          width="18px"
                          height="18px"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                          <g
                            id="SVGRepo_tracerCarrier"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></g>
                          <g id="SVGRepo_iconCarrier">
                            {" "}
                            <path
                              d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z"
                              stroke="#314064"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></path>{" "}
                            <path
                              d="M21 21H12"
                              stroke="#314064"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></path>{" "}
                          </g>
                        </svg>
                        </span>
                        
                        </Tooltip>
                    </div>

                    {/* {passportImg ? (
                    <button
                      className={`individual-claim-view-file-button`}
                      onClick={() => handleViewFile(passportImg)}
                      disabled={!passportImg}
                      style={{
                        ...(passportImg ? {} : { cursor: "not-allowed" }),
                      }}
                      type="button"
                    >
                      <DocumentIcon />
                      {passportImg
                        ? getShortenedFileName(passportImg)
                        : "No File"}
                    </button>
                  ) : (
                    <p>No Document Added</p>
                  )} */}
                    {/* <span>
                    {" "}
                    <div style={{ position: "relative" }}>
                      <input
                        type="file"
                        className="form-control claim-detail-input"
                        {...register("passport", {
                          required: false,
                        })}
                        disabled={true}
                      />
                    </div>
                  </span> */}
                  </div>
                  
                  {
                    (claimData.type_of_claim === "delayed_baggage" || claimData.type_of_claim === "lost/damaged" || claimData.type_of_claim === "lost_wages") &&  <div className="claim-data">
                    <label className="sub-header" style={{ color: "#222222" }}>
                      Luggage Delivered Date
                    </label>
                      <span>
                        
                     {claimData.luggage_delivered ? moment(claimData?.luggage_delivered).format("MM/DD/YYYY") : "No Data"}
                     
                    </span>
                  </div>
                  }


                </div>


              </div>
            </div>

            {familyMembers.length > 0 &&
              familyMembers.map((member, index) => (
                <div
                  className="indivisual-section"
                  // style={{
                  //   borderBottom: "1px solid #EFF3F9",
                  //   padding: "20px 0",
                  // }}
                  key={index}
                >
                  <h6 className="claim-header">Traveler {index + 2}</h6>
                  <div
                    className="claim-data-wrapper"
                    style={{ padding: "20px 0" }}
                  >
                    <div className="claim-data">
                      <label
                        className="sub-header"
                        style={{ color: "#222222" }}
                      >
                        First Name
                      </label>
                      <span>{member?.first_name ?? "No Data"}</span>
                      {/* <span>
                        <input
                          className="form-control  individualClaimInput"
                          placeholder="First Name"
                          type="text"
                          value={member.first_name}
                          onChange={(e) =>
                            handleInputChange(e, index, "first_name")
                          }
                          required
                        />
                      </span> */}
                    </div>

                    <div className="claim-data">
                      <label
                        className="sub-header"
                        style={{ color: "#222222" }}
                      >
                        Last Name
                      </label>
                      <span>{member?.last_name ?? "No Data"}</span>
                      {/* <span>
                        {" "}
                        <input
                          className="form-control  individualClaimInput"
                          placeholder="Last Name"
                          type="text"
                          value={member.last_name}
                          onChange={(e) =>
                            handleInputChange(e, index, "last_name")
                          }
                          required
                        />
                      </span> */}
                    </div>

                    <div className="claim-data">
                      <label
                        className="sub-header"
                        style={{ color: "#222222" }}
                      >
                        Date Of Birth
                      </label>
                      <span>
                        {member?.date_of_birth
                          ? moment(member.date_of_birth).format("MM/DD/YYYY")
                          : "No Data"}
                      </span>
                      {/* <span>
                        {" "}
                        <input
                          className="form-control  individualClaimInput"
                          type="date"
                          value={member.date_of_birth}
                          onChange={(e) =>
                            handleInputChange(e, index, "date_of_birth")
                          }
                          required
                        />
                      </span> */}
                    </div>

                    <div className="claim-data">
                      <label
                        className="sub-header"
                        style={{ color: "#222222" }}
                      >
                        Nationality
                      </label>
                      <span>{member?.country ?? "No Data"}</span>
                    </div>
                  </div>
                  <div
                    className="claim-data-wrapper"
                    style={{ padding: "20px 0" }}
                  >
                    <div className="claim-data">
                      <label
                        className="sub-header"
                        style={{ color: "#222222" }}
                      >
                        Passport Number
                      </label>
                      <span>{member?.passport_number ?? "No Data"}</span>
                      {/* <span>
                        {" "}
                        <input
                          className="form-control individualClaimInput"
                          placeholder="Passport Number"
                          type="text"
                          value={member.passport_number}
                          onChange={(e) =>
                            handleInputChange(e, index, "passport_number")
                          }
                          required
                        />
                      </span> */}
                    </div>
                    <div className="claim-data">
                      <label
                        className="sub-header"
                        style={{ color: "#222222" }}
                      >
                        Ticket Number
                      </label>
                      <span>{member?.tickets ?? "No Data"}</span>
                      {/* <span>
                        <input
                          className="form-control  individualClaimInput"
                          placeholder="Ticket Number"
                          type="text"
                          value={member.tickets}
                          onChange={(e) => handleTicketNumberChange(e, index)}
                          required
                        />
                        {ticketNumberErrors[index] && (
                          <p className="errormessage">
                            {ticketNumberErrors[index]}
                          </p>
                        )}
                      </span> */}
                    </div>

                    <div className="claim-data">
                      <label
                        className="sub-header"
                        style={{ color: "#222222" }}
                      >
                        Airline Reservation Number
                      </label>
                      <span>{member?.airline_res_no ?? "No Data"}</span>
                      {/* <span>
                        <input
                          className="form-control  individualClaimInput"
                          placeholder="Ticket Number"
                          type="text"
                          value={member.tickets}
                          onChange={(e) => handleTicketNumberChange(e, index)}
                          required
                        />
                        {ticketNumberErrors[index] && (
                          <p className="errormessage">
                            {ticketNumberErrors[index]}
                          </p>
                        )}
                      </span> */}
                    </div>

                    <div className="claim-data mobile-view-claim-data">
                      <div
                        className="d-flex align-items-center"
                        style={{
                          flexDirection: "row",
                          justifyContent: "space-between",
                        }}
                      >
                        <label
                          className="sub-header"
                          style={{ color: "#222222" }}
                        >
                          Boarding Pass
                        </label>
                        {/* add boardinging here if want to revert to previous design */}
                      </div>
                      <div className="file-wrapper">
                        {member.boarding_pass ? (
                          <button
                            className={`individual-claim-view-file-button`}
                            style={{
                              ...(member.boarding_pass
                                ? {}
                                : { cursor: "not-allowed" }),
                            }}
                            onClick={() => handleViewFile(member.boarding_pass)}
                            disabled={!member.boarding_pass}
                            type="button"
                          >
                            {/* {member.boarding_pass ? "View File" : "No File"} */}
                            <DocumentIcon />
                            {member.boarding_pass
                              ? getShortenedFileName(member.boarding_pass)
                              : "No File"}
                          </button>
                        ) : member.update_boarding_pass ? (
                          <button
                            className={`individual-claim-view-file-button`}
                            onClick={() =>
                              handleViewUpdatedFile(member.update_boarding_pass)
                            }
                            type="button"
                          >
                            {/* {boardingImg ? "View File" : "No File"} */}
                            <DocumentIcon />
                            {member.update_boarding_pass
                              ? getShortUpdatedFilename(
                                  member.update_boarding_pass
                                )
                              : "No File"}
                          </button>
                        ) : (
                          <p>No Document Added</p>
                        )}

                        <input
                          style={{ display: "none" }}
                          ref={(el) => {
                            if (!subClaimFilesRef.current[index]) {
                              subClaimFilesRef.current[index] = {};
                            }
                            subClaimFilesRef.current[index]["boarding_pass"] =
                              el;
                          }}
                          onChange={(e) =>
                            handleSubClaimFileChange(e, index, "boarding_pass")
                          }
                          type="file"
                          className="form-control mt-2"
                          name="boarding_pass"
                        />

                         <Tooltip label="Edit File">
                        <span
                          onClick={() =>
                            triggerSubClaimFileInput(index, "boarding_pass")
                          }
                          className={`individual-claim-view-file-button`}
                          style={{
                            borderRadius: "4px",
                            height: "100%",
                            cursor: "pointer",
                          }}
                        >
                          <svg
                            width="18px"
                            height="18px"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g
                              id="SVGRepo_tracerCarrier"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></g>
                            <g id="SVGRepo_iconCarrier">
                              {" "}
                              <path
                                d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z"
                                stroke="#314064"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              ></path>{" "}
                              <path
                                d="M21 21H12"
                                stroke="#314064"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              ></path>{" "}
                            </g>
                          </svg>
                          </span>
                          </Tooltip>
                      </div>
                    </div>
                  </div>

                  <div
                    className="claim-data-wrapper"
                    style={{ padding: "20px 0" }}
                  >
                    <div className="claim-data mobile-view-claim-data">
                      <div
                        className="d-flex align-items-center"
                        style={{
                          flexDirection: "row",
                          justifyContent: "space-between",
                        }}
                      >
                        <label
                          className="sub-header"
                          style={{ color: "#222222" }}
                        >
                          Passport
                        </label>
                        {/* add boardinging here if want to revert to previous design */}
                      </div>
                      <div className="file-wrapper">
                        {member.passport ? (
                          <button
                            className={`individual-claim-view-file-button`}
                            style={{
                              ...(member.passport
                                ? {}
                                : { cursor: "not-allowed" }),
                            }}
                            onClick={() => handleViewFile(member.passport)}
                            disabled={!member.passport}
                            type="button"
                          >
                            {/* {member.passport ? "View File" : "No File"} */}
                            <DocumentIcon />
                            {member.passport
                              ? getShortenedFileName(member.passport)
                              : "No File"}
                          </button>
                        ) : member.update_passport ? (
                          <button
                            className={`individual-claim-view-file-button`}
                            onClick={() =>
                              handleViewUpdatedFile(member.update_passport)
                            }
                            type="button"
                          >
                            {/* {boardingImg ? "View File" : "No File"} */}
                            <DocumentIcon />
                            {member.update_passport
                              ? getShortUpdatedFilename(member.update_passport)
                              : "No File"}
                          </button>
                        ) : (
                          <p>No Document Added</p>
                        )}

                        <input
                          style={{ display: "none" }}
                          ref={(el) => {
                            if (!subClaimFilesRef.current[index]) {
                              subClaimFilesRef.current[index] = {};
                            }
                            subClaimFilesRef.current[index]["passport"] = el;
                          }}
                          onChange={(e) =>
                            handleSubClaimFileChange(e, index, "passport")
                          }
                          type="file"
                          className="form-control mt-2"
                          name="passport"
                        />

                         <Tooltip label="Edit File">
                        <span
                          onClick={() =>
                            triggerSubClaimFileInput(index, "passport")
                          }
                          className={`individual-claim-view-file-button`}
                          style={{
                            borderRadius: "4px",
                            height: "100%",
                            cursor: "pointer",
                          }}
                        >
                          <svg
                            width="18px"
                            height="18px"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g
                              id="SVGRepo_tracerCarrier"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></g>
                            <g id="SVGRepo_iconCarrier">
                              {" "}
                              <path
                                d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z"
                                stroke="#314064"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              ></path>{" "}
                              <path
                                d="M21 21H12"
                                stroke="#314064"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              ></path>{" "}
                            </g>
                          </svg>
                          </span>
                          </Tooltip>
                      </div>
                    </div>
                    {/* <div className="claim-data mobile-view-claim-data">
                      <div
                        className="d-flex align-items-center"
                        style={{
                          flexDirection: "row",
                          justifyContent: "space-between",
                        }}
                      >
                        <label
                          className="sub-header"
                          style={{ color: "#222222" }}
                        >
                          Additional Document
                        </label>
                      
                      </div>
                      <div className="file-wrapper">
                        {member.additional_doc ? (
                          <button
                            className={`individual-claim-view-file-button`}
                            style={{
                              ...(member.additional_doc
                                ? {}
                                : { cursor: "not-allowed" }),
                            }}
                            onClick={() =>
                              handleViewFile(member.additional_doc)
                            }
                            disabled={!member.additional_doc}
                            type="button"
                          >
                          
                            <DocumentIcon />
                            {member.additional_doc
                              ? getShortenedFileName(member.additional_doc)
                              : "No File"}
                          </button>
                        ) : member.update_additional_doc ? (
                          <button
                            className={`individual-claim-view-file-button`}
                            onClick={() =>
                              handleViewUpdatedFile(
                                member.update_additional_doc
                              )
                            }
                            type="button"
                          >
                           
                            <DocumentIcon />
                            {member.update_additional_doc
                              ? getShortUpdatedFilename(
                                  member.update_additional_doc
                                )
                              : "No File"}
                          </button>
                        ) : (
                          <p>No Document Added</p>
                        )}

                        <input
                          style={{ display: "none" }}
                          ref={(el) => {
                            if (!subClaimFilesRef.current[index]) {
                              subClaimFilesRef.current[index] = {};
                            }
                            subClaimFilesRef.current[index]["additional_doc"] =
                              el;
                          }}
                          onChange={(e) =>
                            handleSubClaimFileChange(e, index, "additional_doc")
                          }
                          type="file"
                          className="form-control mt-2"
                          name="additional_doc"
                        />
                        <span
                          onClick={() =>
                            triggerSubClaimFileInput(index, "additional_doc")
                          }
                          className={`individual-claim-view-file-button`}
                          style={{
                            borderRadius: "4px",
                            height: "100%",
                            cursor: "pointer",
                          }}
                        >
                          <svg
                            width="18px"
                            height="18px"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g
                              id="SVGRepo_tracerCarrier"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></g>
                            <g id="SVGRepo_iconCarrier">
                              {" "}
                              <path
                                d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z"
                                stroke="#314064"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              ></path>{" "}
                              <path
                                d="M21 21H12"
                                stroke="#314064"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              ></path>{" "}
                            </g>
                          </svg>
                        </span>
                      </div>
                    </div> */}

                    <div className="claim-data"></div>
                    <div className="claim-data"></div>
                    <div className="claim-data"></div>
                  </div>
                </div>
              ))}

            {flightDetails.length > 0 && <h4 style={{ marginTop: "20px" }} className="claim-header-head">
              {claimData.type_of_claim === "flight delay / flight cancellation"
                ? "Flight Details(Originally Booked)"
                : "Flight Details(Originally Booked)"}
            </h4>}
           

            {flightDetails.length > 0 &&
              flightDetails.map((flight, index) => (
                <div
                  className="indivisual-section"
                  key={index}
                  // style={{
                  //   borderBottom: "1px solid #EFF3F9",
                  //   padding: "10px 0",
                  // }}
                >
                  <h6 className="claim-header">Flight {index + 1}</h6>

                  <div
                    className="claim-data-wrapper"
                    style={{ padding: "20px 0" }}
                  >
                    <div className="claim-data">
                      <label
                        className="sub-header"
                        style={{ color: "#222222" }}
                      >
                        Airline
                      </label>
                      <span>{flight?.airline ?? "No Data"}</span>
                      {/* <span>
                        {" "}
                        <Controller
                          name={`Airline_${index}`}
                          control={control}
                          rules={{ required: false }}
                          render={({ field }) => (
                            <AsyncSelect
                              styles={selectStyles}
                              {...field}
                              cacheOptions
                              defaultOptions={defaultAirlineOptions}
                              loadOptions={loadAirlineOptions}
                              value={
                                flight.airline
                                  ? {
                                      label: flight.airline,
                                      value: flight.airline,
                                    }
                                  : null
                              }
                              placeholder="Select Airline"
                              // onChange={(selectedOption) => {
                              //   setFlightDetails((prevState) => {
                              //     const updatedFlightDetails = [...prevState];
                              //     updatedFlightDetails[index].hub_code =
                              //       selectedOption?.hub_code || "";

                              //     updatedFlightDetails[index].airline =
                              //       selectedOption?.label || "";
                              //     return updatedFlightDetails;
                              //   });
                              //   setTriggerIndex(index);
                              //   setTriggerFrom("original");
                              //   field.onChange(selectedOption?.label || "");
                              // }}
                              isDisabled={true}
                            />
                          )}
                        />
                      </span> */}
                    </div>

                    <div className="claim-data">
                      <label
                        className="sub-header"
                        style={{ color: "#222222" }}
                      >
                        Flight Number
                      </label>
                      <span>{flight?.flight_number ?? "No Data"}</span>
                      {/* <span>
                        {" "}
                        <input
                          className="form-control extra-light  individualClaimInput"
                          placeholder="Flight Number"
                          type="text"
                          value={flight.flight_number}
                          // onChange={(e) => {
                          //   const updatedFlightDetails = [...flightDetails];
                          //   updatedFlightDetails[index].flight_number =
                          //     e.target.value;
                          //   setFlightDetails(updatedFlightDetails);
                          //   setTriggerIndex(index);
                          //   setTriggerFrom("original");
                          // }}
                          disabled
                        />
                      </span> */}
                    </div>

                    <div className="claim-data">
                      <label
                        className="sub-header"
                        style={{ color: "#222222" }}
                      >
                        Flight Class
                      </label>
                      <span>{flight?.flight_class ?? "No Data"}</span>
                    </div>

                    <div className="claim-data">
                      <label
                        className="sub-header"
                        style={{ color: "#222222" }}
                      >
                        Airport of Origin
                      </label>
                      <span>{flight?.airport_of_origin ?? "No Data"}</span>
                      {/* <span>
                        {" "}
                        {flightOptions[index] &&
                        flightOptions[index].length > 0 ? (
                          <div style={{ position: "relative" }}>
                            <Controller
                              name={`airport_of_origin_${index}`}
                              control={control}
                              rules={{
                                required: false,
                              }}
                              render={({ field }) => (
                                <AsyncSelect
                                  styles={selectStyles}
                                  {...field}
                                  cacheOptions
                                  defaultOptions={flightOptions[index].map(
                                    (option) => ({
                                      value: option.departure.airport,
                                      arrival: option.arrival.airport,
                                      departure: option.departure.airport,
                                      label: `${option.departure.airport} - ${option.arrival.airport}`,
                                    })
                                  )}
                                  value={
                                    flight.airport_of_origin
                                      ? {
                                          label: flight.airport_of_origin,
                                          value: flight.airport_of_origin,
                                        }
                                      : null
                                  }
                                  placeholder="Select Origin Airport"
                                  // onChange={(selectedOption) => {
                                  //   console.log(
                                  //     "selectedOptions 1360",
                                  //     selectedOption
                                  //   );
                                  //   setTriggerIndex(null);
                                  //   const updatedFlightDetails = [
                                  //     ...flightDetails,
                                  //   ];
                                  //   updatedFlightDetails[
                                  //     index
                                  //   ].airport_of_origin =
                                  //     selectedOption?.departure || "";
                                  //   updatedFlightDetails[
                                  //     index
                                  //   ].airport_of_destination =
                                  //     selectedOption?.arrival || "";
                                  //   setFlightDetails(updatedFlightDetails);
                                  //   field.onChange(selectedOption?.label || "");
                                  // }}
                                  isDisabled={true}
                                />
                              )}
                            />
                          </div>
                        ) : (
                          <div style={{ position: "relative" }}>
                            <Controller
                              name={`airport_of_origin_${index}`}
                              control={control}
                              defaultValue={flight.airport_of_origin}
                              rules={{
                                required: false,
                              }}
                              render={({ field }) => (
                                <AsyncSelect
                                  {...field}
                                  styles={selectStyles}
                                  cacheOptions
                                  loadOptions={loadOptions}
                                  defaultOptions={defaultOptions}
                                  value={
                                    flight.airport_of_origin
                                      ? {
                                          label: flight.airport_of_origin,
                                          value: flight.airport_of_origin,
                                        }
                                      : null
                                  }
                                  placeholder="Select Origin Airport"
                                  // onChange={(selectedOption) => {
                                  //   setTriggerIndex(null);
                                  //   const updatedFlightDetails = [
                                  //     ...flightDetails,
                                  //   ];
                                  //   updatedFlightDetails[
                                  //     index
                                  //   ].airport_of_origin =
                                  //     selectedOption?.label || "";
                                  //   setFlightDetails(updatedFlightDetails);
                                  //   field.onChange(selectedOption?.label || "");
                                  // }}
                                  isDisabled={true}
                                />
                              )}
                            />
                          </div>
                        )}
                      </span> */}
                    </div>
                  </div>
                  <div
                    className="claim-data-wrapper"
                    style={{ padding: "20px 0" }}
                  >
                    <div className="claim-data">
                      <label
                        className="sub-header"
                        style={{ color: "#222222" }}
                      >
                        Departure
                      </label>
                      <span>
                        {flight?.date_of_travel
                          ? moment(flight?.date_of_travel).format("MM/DD/YYYY")
                          : ""}{" "}
                        {flight.original_departure_time
                          ? moment(
                              flight.original_departure_time,
                              "HH:mm"
                            ).format("hh:mm A")
                          : ""}
                      </span>
                      {/* <span>
                        {" "}
                        <input
                          type="time"
                          className="form-control extra-light  individualClaimInput"
                          value={flight.original_departure_time}
                          // onChange={(e) => {
                          //   const updatedFlightDetails = [...flightDetails];
                          //   const updatedTime = e.target.value;
                          //   updatedFlightDetails[
                          //     index
                          //   ].original_departure_time = updatedTime;

                          //   setFlightDetails(updatedFlightDetails);
                          //   setTriggerIndex(null);
                          // }}
                          disabled
                        />
                      </span> */}
                    </div>

                    <div className="claim-data">
                      <label
                        className="sub-header"
                        style={{ color: "#222222" }}
                      >
                        Airport of Destination
                      </label>
                      <span>{flight?.airport_of_destination ?? "No Data"}</span>
                      {/* <span>
                        {" "}
                        {flightOptions[index] &&
                        flightOptions[index].length > 0 ? (
                          <div style={{ position: "relative" }}>
                            <Controller
                              name={`airport_of_destination_${index}`}
                              control={control}
                              rules={{
                                required: false,
                              }}
                              render={({ field }) => (
                                <AsyncSelect
                                  styles={selectStyles}
                                  {...field}
                                  cacheOptions
                                  defaultOptions={flightOptions[index].map(
                                    (option) => ({
                                      value: option.arrival.airport,
                                      arrival: option.arrival.airport,
                                      departure: option.departure.airport,
                                      label: `${option.departure.airport} - ${option.arrival.airport}`,
                                    })
                                  )}
                                  value={
                                    flight.airport_of_destination
                                      ? {
                                          label: flight.airport_of_destination,
                                          value: flight.airport_of_destination,
                                        }
                                      : null
                                  }
                                  placeholder="Select Origin Airport"
                                  // onChange={(selectedOption) => {
                                  //   console.log(
                                  //     "selectedOptions 1466",
                                  //     selectedOption
                                  //   );
                                  //   setTriggerIndex(null);
                                  //   const updatedFlightDetails = [
                                  //     ...flightDetails,
                                  //   ];
                                  //   updatedFlightDetails[
                                  //     index
                                  //   ].airport_of_origin =
                                  //     selectedOption?.departure || "";
                                  //   updatedFlightDetails[
                                  //     index
                                  //   ].airport_of_destination =
                                  //     selectedOption?.arrival || "";
                                  //   setFlightDetails(updatedFlightDetails);
                                  //   field.onChange(selectedOption?.label || "");
                                  // }}
                                  isDisabled={true}
                                />
                              )}
                            />
                          </div>
                        ) : (
                          <div style={{ position: "relative" }}>
                            <Controller
                              name={`airport_of_destination_${index}`}
                              control={control}
                              defaultValue={flight.airport_of_destination}
                              rules={{
                                required: false,
                              }}
                              render={({ field }) => (
                                <AsyncSelect
                                  styles={selectStyles}
                                  {...field}
                                  cacheOptions
                                  loadOptions={loadOptions}
                                  defaultOptions={defaultOptions}
                                  value={
                                    flight.airport_of_destination
                                      ? {
                                          label: flight.airport_of_destination,
                                          value: flight.airport_of_destination,
                                        }
                                      : null
                                  }
                                  placeholder="Select Destination Airport"
                                  // onChange={(selectedOption) => {
                                  //   setTriggerIndex(null);
                                  //   const updatedFlightDetails = [
                                  //     ...flightDetails,
                                  //   ];
                                  //   updatedFlightDetails[
                                  //     index
                                  //   ].airport_of_destination =
                                  //     selectedOption?.label || "";
                                  //   setFlightDetails(updatedFlightDetails);
                                  //   field.onChange(selectedOption?.label || "");
                                  // }}
                                  isDisabled={true}
                                />
                              )}
                            />
                          </div>
                        )}
                      </span> */}
                    </div>

                    <div className="claim-data">
                      <label
                        className="sub-header"
                        style={{ color: "#222222" }}
                      >
                        Arrival
                      </label>
                      <span>
                        {flight?.original_arrival_date
                          ? moment(flight?.original_arrival_date).format(
                              "MM/DD/YYYY"
                            )
                          : ""}{" "}
                        {flight.original_arrival_time
                          ? moment(
                              flight.original_arrival_time,
                              "HH:mm"
                            ).format("hh:mm A")
                          : ""}
                      </span>
                      {/* <span>
                        {" "}
                        <input
                          type="date"
                          className="form-control extra-light  individualClaimInput"
                          name="original_arrival_date"
                          value={flight.original_arrival_date}
                          // onChange={(e) => {
                          //   const updatedFlightDetails = [...flightDetails];
                          //   const updatedDate = e.target.value;
                          //   updatedFlightDetails[
                          //     index
                          //   ].original_arrival_date = updatedDate;

                          //   setFlightDetails(updatedFlightDetails);
                          //   setTriggerIndex(null);
                          // }}
                          disabled
                        />
                      </span> */}
                    </div>

                    {/* <div className="claim-data">
                      <label
                        className="sub-header"
                        style={{ color: "#222222" }}
                      >
                        Ticket Reference Number
                      </label>
                      <span>{flight?.ticket_ref_no ?? "No Data"}</span>
                    </div> */}
                    <div className="claim-data"></div>
                  </div>

                  <div
                    className="claim-data-wrapper"
                    style={{ padding: "20px 0" }}
                  >
                    {claimData.type_of_claim ===
                      "flight delay / flight cancellation" && (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          flexWrap: "wrap",
                          gap: "15px",
                        }}
                      >
                        {/* Delayed Checkbox */}
                        <div className="form-check ">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            checked={flight.delayed}
                            // onChange={() =>
                            //   setFlightDetails((prevState) => {
                            //     const updatedFlightDetails = [...prevState];
                            //     updatedFlightDetails[index] = {
                            //       ...updatedFlightDetails[index],
                            //       delayed: !flight.delayed,
                            //       cancelled: false, // Explicitly uncheck Cancelled
                            //       missed: false, // Explicitly uncheck Missed
                            //     };
                            //     return updatedFlightDetails;
                            //   })
                            // }
                            disabled
                          />
                          <label className="form-check-label ">Delayed</label>
                        </div>

                        {/* Cancelled Checkbox */}
                        <div className="form-check ">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            checked={flight.cancelled}
                            // onChange={() =>
                            //   setFlightDetails((prevState) => {
                            //     const updatedFlightDetails = [...prevState];
                            //     updatedFlightDetails[index] = {
                            //       ...updatedFlightDetails[index],
                            //       cancelled: !flight.cancelled,
                            //       delayed: false, // Explicitly uncheck Delayed
                            //       missed: false, // Explicitly uncheck Missed
                            //     };
                            //     return updatedFlightDetails;
                            //   })
                            // }
                            disabled
                          />
                          <label className="form-check-label ">Cancelled</label>
                        </div>

                        {/* Missed Checkbox */}
                        <div className="form-check ">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            checked={flight.missed}
                            // onChange={() =>
                            //   setFlightDetails((prevState) => {
                            //     const updatedFlightDetails = [...prevState];
                            //     updatedFlightDetails[index] = {
                            //       ...updatedFlightDetails[index],
                            //       missed: !flight.missed,
                            //       delayed: false, // Explicitly uncheck Delayed
                            //       cancelled: false, // Explicitly uncheck Cancelled
                            //     };
                            //     return updatedFlightDetails;
                            //   })
                            // }
                            disabled
                          />
                          <label className="form-check-label ">Missed</label>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ))}

            {actualFlightDetails.length > 0 && (
              <>
                <h4 className="claim-header-head" style={{marginTop:"20px"}}>
                  Flight Details(Actual Flight)
                </h4>
                {actualFlightDetails.map((flight, index) => (
                  <div className="indivisual-section">
                    <h6
                      className="claim-header"
                      // style={{ marginTop: "15px" }}
                      key={index}
                    >
                      Flight {index + 1}{" "}
                    </h6>
                    {claimData.type_of_claim ===
                      "flight delay / flight cancellation" && (
                      <h4
                        style={{
                          margin: 0,
                          marginTop: "10px",
                          fontWeight: "500",
                          fontSize: "14px",
                          color: "#222222",
                        }}
                      >
                        {flight.provided_by_airline && "Provided by Airline"}{" "}
                        {flight.self_booked && "Self Booked"}
                      </h4>
                    )}

                    <div
                      className="claim-data-wrapper"
                      style={{ padding: "20px 0" }}
                    >
                      <div className="claim-data">
                        <label
                          className="sub-header"
                          style={{ color: "#222222" }}
                        >
                          Airline
                        </label>
                        <span>{flight?.actual_airline ?? "No Data"}</span>
                        {/* <span>
                            {" "}
                            <Controller
                              name={`Actual_Airline_${index}`}
                              control={control}
                              rules={{
                                required: false,
                              }} // Mandatory for the first flight
                              render={({ field }) => (
                                <AsyncSelect
                                  {...field}
                                  cacheOptions
                                  defaultOptions={defaultAirlineOptions}
                                  loadOptions={loadAirlineOptions}
                                  value={
                                    flight.actual_airline
                                      ? {
                                          label: flight.actual_airline,
                                          value: flight.actual_airline,
                                        }
                                      : null
                                  }
                                  placeholder="Select Airline"
                                  // onChange={(selectedOption) => {
                                  //   setActualFlightDetails((prevState) => {
                                  //     const updatedFlightDetails = [
                                  //       ...prevState,
                                  //     ];
                                  //     updatedFlightDetails[
                                  //       index
                                  //     ].actual_hub_code =
                                  //       selectedOption?.hub_code || "";

                                  //     updatedFlightDetails[
                                  //       index
                                  //     ].actual_airline =
                                  //       selectedOption?.label || "";
                                  //     return updatedFlightDetails;
                                  //   });
                                  //   setTriggerIndex(index);
                                  //   setTriggerFrom("actual");
                                  //   field.onChange(
                                  //     selectedOption?.label || ""
                                  //   );
                                  // }}
                                  isDisabled={true}
                                />
                              )}
                            />
                          </span> */}
                      </div>

                      <div className="claim-data">
                        <label
                          className="sub-header"
                          style={{ color: "#222222" }}
                        >
                          Flight Number
                        </label>
                        <span>{flight?.actual_flight_number ?? "No Data"}</span>
                        {/* <span>
                            {" "}
                            <input
                              className="form-control extra-light"
                              placeholder="Flight Number"
                              type="text"
                              value={flight.actual_flight_number}
                              // onChange={(e) => {
                              //   const updatedFlightDetails = [
                              //     ...actualFlightDetails,
                              //   ];
                              //   updatedFlightDetails[
                              //     index
                              //   ].actual_flight_number = e.target.value;
                              //   setActualFlightDetails(updatedFlightDetails);
                              //   setTriggerIndex(index);
                              //   setTriggerFrom("actual");
                              // }}
                              disabled
                            />
                          </span> */}
                      </div>

                      <div className="claim-data">
                        <label
                          className="sub-header"
                          style={{ color: "#222222" }}
                        >
                          Flight Class
                        </label>
                        <span>{flight?.actual_flight_class ?? "No Data"}</span>
                      </div>

                      <div className="claim-data">
                        <label
                          className="sub-header"
                          style={{ color: "#222222" }}
                        >
                          Airport of Origin
                        </label>
                        <span>
                          {flight?.actual_airport_of_origin ?? "No Data"}
                        </span>
                        {/* <span>
                            {" "}
                            {flightOptions[index] &&
                            flightOptions[index].length > 0 ? (
                              <div style={{ position: "relative" }}>
                                <Controller
                                  name={`actual_airport_of_origin_${index}`}
                                  control={control}
                                  rules={{
                                    required: false,
                                  }}
                                  render={({ field }) => (
                                    <AsyncSelect
                                      styles={selectStyles}
                                      {...field}
                                      cacheOptions
                                      defaultOptions={flightOptions[index].map(
                                        (option) => ({
                                          value: option.departure.airport,
                                          arrival: option.arrival.airport,
                                          departure: option.departure.airport,
                                          label: `${option.departure.airport} - ${option.arrival.airport}`,
                                        })
                                      )}
                                      value={
                                        flight.actual_airport_of_origin
                                          ? {
                                              label:
                                                flight.actual_airport_of_origin,
                                              value:
                                                flight.actual_airport_of_origin,
                                            }
                                          : null
                                      }
                                      placeholder="Select Origin Airport"
                                      // onChange={(selectedOption) => {
                                      //   console.log(
                                      //     "selectedOptions 1360",
                                      //     selectedOption
                                      //   );
                                      //   setTriggerIndex(null);
                                      //   const updatedFlightDetails = [
                                      //     ...actualFlightDetails,
                                      //   ];
                                      //   updatedFlightDetails[
                                      //     index
                                      //   ].actual_airport_of_origin =
                                      //     selectedOption?.label || "";

                                      //   setActualFlightDetails(
                                      //     updatedFlightDetails
                                      //   );
                                      //   field.onChange(
                                      //     selectedOption?.label || ""
                                      //   );
                                      // }}
                                      isDisabled={true}
                                    />
                                  )}
                                />
                                {errors[
                                  `actual_airport_of_origin_${index}`
                                ] && (
                                  <p className="errormessage">
                                    Origin Airport is Required
                                  </p>
                                )}
                              </div>
                            ) : (
                              <div style={{ position: "relative" }}>
                                <Controller
                                  name={`actual_airport_of_origin_${index}`}
                                  control={control}
                                  rules={{
                                    required: false,
                                  }}
                                  render={({ field }) => (
                                    <AsyncSelect
                                      styles={selectStyles}
                                      {...field}
                                      cacheOptions
                                      loadOptions={loadOptions}
                                      defaultOptions={defaultOptions}
                                      value={
                                        flight.actual_airport_of_origin
                                          ? {
                                              label:
                                                flight.actual_airport_of_origin,
                                              value:
                                                flight.actual_airport_of_origin,
                                            }
                                          : null
                                      }
                                      placeholder="Select Origin Airport"
                                      // onChange={(selectedOption) => {
                                      //   setTriggerIndex(null);
                                      //   const updatedFlightDetails = [
                                      //     ...actualFlightDetails,
                                      //   ];
                                      //   updatedFlightDetails[
                                      //     index
                                      //   ].actual_airport_of_origin =
                                      //     selectedOption?.label || "";
                                      //   setActualFlightDetails(
                                      //     updatedFlightDetails
                                      //   );
                                      //   field.onChange(
                                      //     selectedOption?.label || ""
                                      //   );
                                      // }}
                                      isDisabled={true}
                                    />
                                  )}
                                />
                                {errors[
                                  `actual_airport_of_origin_${index}`
                                ] && (
                                  <p className="errormessage">
                                    Origin Airport is Required
                                  </p>
                                )}
                              </div>
                            )}
                          </span> */}
                      </div>
                    </div>
                    <div
                      className="claim-data-wrapper"
                      style={{ padding: "20px 0" }}
                    >
                      <div className="claim-data">
                        <label
                          className="sub-header"
                          style={{ color: "#222222" }}
                        >
                          Departure
                        </label>
                        <span>
                          {flight?.actual_date_of_travel
                            ? moment(flight?.actual_date_of_travel).format(
                                "MM/DD/YYYY"
                              )
                            : ""}{" "}
                          {flight.actual_departure_time
                            ? moment(
                                flight.actual_departure_time,
                                "HH:mm"
                              ).format("hh:mm A")
                            : ""}
                        </span>
                        {/* <span>
                            {" "}
                            <input
                              type="time"
                              className="form-control extra-light"
                              value={flight.actual_departure_time}
                              // onChange={(e) => {
                              //   const updatedFlightDetails = [
                              //     ...actualFlightDetails,
                              //   ];
                              //   const updatedTime = e.target.value;

                              //   updatedFlightDetails[
                              //     index
                              //   ].actual_departure_time = updatedTime;
                              //   setActualFlightDetails(updatedFlightDetails);
                              //   setTriggerIndex(null);
                              // }}
                              disabled
                            />
                          </span> */}
                      </div>

                      <div className="claim-data">
                        <label
                          className="sub-header"
                          style={{ color: "#222222" }}
                        >
                          Airport of Destination
                        </label>
                        <span>
                          {flight?.actual_airport_of_destination ?? "No Data"}
                        </span>
                        {/* <span>
                            {" "}
                            {flightOptions[index] &&
                            flightOptions[index].length > 0 ? (
                              <div style={{ position: "relative" }}>
                                <Controller
                                  name={`actual_airport_of_destination_${index}`}
                                  control={control}
                                  rules={{
                                    required: false,
                                  }}
                                  render={({ field }) => (
                                    <AsyncSelect
                                      {...field}
                                      cacheOptions
                                      defaultOptions={flightOptions[index].map(
                                        (option) => ({
                                          value: option.arrival.airport,
                                          arrival: option.arrival.airport,
                                          departure: option.departure.airport,
                                          label: `${option.departure.airport} - ${option.arrival.airport}`,
                                        })
                                      )}
                                      value={
                                        flight.actual_airport_of_destination
                                          ? {
                                              label:
                                                flight.actual_airport_of_destination,
                                              value:
                                                flight.actual_airport_of_destination,
                                            }
                                          : null
                                      }
                                      placeholder="Select Origin Airport"
                                      // onChange={(selectedOption) => {
                                      //   console.log(
                                      //     "selectedOptions 1466",
                                      //     selectedOption
                                      //   );
                                      //   setTriggerIndex(null);
                                      //   const updatedFlightDetails = [
                                      //     ...actualFlightDetails,
                                      //   ];

                                      //   updatedFlightDetails[
                                      //     index
                                      //   ].actual_airport_of_destination =
                                      //     selectedOption?.label || "";
                                      //   setActualFlightDetails(
                                      //     updatedFlightDetails
                                      //   );
                                      //   field.onChange(
                                      //     selectedOption?.label || ""
                                      //   );
                                      // }}
                                      isDisabled={true}
                                    />
                                  )}
                                />
                                {errors[
                                  `actual_airport_of_destination_${index}`
                                ] && (
                                  <p className="errormessage">
                                    Destination Airport is Required
                                  </p>
                                )}
                              </div>
                            ) : (
                              <div style={{ position: "relative" }}>
                                <Controller
                                  name={`actual_airport_of_destination_${index}`}
                                  control={control}
                                  defaultValue={
                                    flight.actual_airport_of_destination
                                  }
                                  rules={{
                                    required: false,
                                  }}
                                  render={({ field }) => (
                                    <AsyncSelect
                                      {...field}
                                      cacheOptions
                                      loadOptions={loadOptions}
                                      defaultOptions={defaultOptions}
                                      value={
                                        flight.actual_airport_of_destination
                                          ? {
                                              label:
                                                flight.actual_airport_of_destination,
                                              value:
                                                flight.actual_airport_of_destination,
                                            }
                                          : null
                                      }
                                      placeholder="Select Destination Airport"
                                      // onChange={(selectedOption) => {
                                      //   setTriggerIndex(null);
                                      //   const updatedFlightDetails = [
                                      //     ...actualFlightDetails,
                                      //   ];
                                      //   updatedFlightDetails[
                                      //     index
                                      //   ].actual_airport_of_destination =
                                      //     selectedOption?.label || "";
                                      //   setActualFlightDetails(
                                      //     updatedFlightDetails
                                      //   );
                                      //   field.onChange(
                                      //     selectedOption?.label || ""
                                      //   );
                                      // }}
                                      isDisabled={true}
                                    />
                                  )}
                                />
                                {errors[
                                  `actual_airport_of_destination_${index}`
                                ] && (
                                  <p className="errormessage">
                                    Destination Airport is Required
                                  </p>
                                )}
                              </div>
                            )}
                          </span> */}
                      </div>

                      <div className="claim-data">
                        <label
                          className="sub-header"
                          style={{ color: "#222222" }}
                        >
                          Arrival
                        </label>
                        <span>
                          {flight?.actual_arrival_date
                            ? moment(flight?.actual_arrival_date).format(
                                "MM/DD/YYYY"
                              )
                            : ""}{" "}
                          {flight.actual_arrival_time
                            ? moment(
                                flight.actual_arrival_time,
                                "HH:mm"
                              ).format("hh:mm A")
                            : ""}
                        </span>
                        {/* <span>
                            {" "}
                            <input
                              type="date"
                              className="form-control extra-light"
                              value={flight.actual_arrival_date}
                              // onChange={(e) => {
                              //   const updatedFlightDetails = [
                              //     ...actualFlightDetails,
                              //   ];
                              //   const updatedDate = e.target.value;
                              //   updatedFlightDetails[
                              //     index
                              //   ].actual_arrival_date = updatedDate;

                              //   setActualFlightDetails(updatedFlightDetails);
                              //   setTriggerIndex(null);
                              // }}
                              disabled
                            />
                          </span> */}
                      </div>

                      {/* <div className="claim-data">
                        <label
                          className="sub-header"
                          style={{ color: "#222222" }}
                        >
                          Ticket Reference Number
                        </label>
                        <span>{flight?.ticket_ref_no ?? "No Data"}</span>
                     
                      </div> */}

                      <div className="claim-data"></div>
                    </div>
                  </div>
                ))}
              </>
            )}

          

            {claimData.type_of_claim ===
              "flight delay / flight cancellation" && (
              <>
                <div
                  className="claim-data-wrapper"
                  style={{ padding: "20px 0" }}
                >
                  <Row>
                    <div className="col-md-4">
                      <label>
                        Delay (hours:minutes)
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <div style={{ position: "relative" }}>
                        <div style={{ display: "flex", gap: "20px" }}>
                          <span>{delay?.split(":")[0]}</span>
                          <span>{delay?.split(":")[1]}</span>
                          {/* <input
                            type="text"
                            className="form-control"
                            value={delay?.split(":")[0]} // Extract hours
                            readOnly
                            style={{ width: "40%" }}
                            placeholder="HH"
                          /> */}
                          {/* <input
                            type="text"
                            className="form-control"
                            value={delay?.split(":")[1]} // Extract minutes
                            readOnly
                            style={{ width: "40%" }}
                            placeholder="MM"
                          /> */}
                        </div>
                      </div>
                    </div>
                  </Row>
                </div>
              </>
            )}
            {/* <div style={{ padding: "20px 0" }}>
              <h6 className="claim-header">Additional details</h6>
              <p
                className="sub-header"
                style={{
                  color: "#222222",
                  marginTop: "20px",
                  backgroundColor: "#EFF3F9",
                  padding: "14px 24px",
                  borderRadius: "24px",
                }}
              >
                The flight was delayed due to technical issues with the
                aircraft. Passengers were kept waiting at the gate for updates.
                Eventually, the airline provided meal vouchers, but no
                accommodation was offered as the delay extended overnight.
                {claimData?.claim_details === ""
                  ? "No Additional details"
                  : claimData?.claim_details}
              </p>
            </div> */}
          </div>

          <div className="delay-duration-wrapper" style={{display:"flex",justifyContent:"center",alignItems:"center"}}>
  {
           (claimData?.type_of_claim === "delayed" || claimData?.type_of_claim === "flight delay / flight cancellation" || claimData?.type_of_claim === "denied_boarding") && claimData?.delay_duration_minutes && claimData?.delay_duration_minutes !== "" && <div className="claim-data delay-time" style={{flexDirection:"row",flex:"initial",alignItems:"center",gap:"10px",width:"fit-content",border:"2px solid #eff3f9"}}>

            <label >Delay Time: </label>
            <span style={{color:"#ff4949"}}>{getDelayDuration(claimData?.delay_duration_minutes)}</span>

          </div>
            }
            

              {
           (claimData?.type_of_claim === "lost/damaged" || claimData.type_of_claim === "lost_wages" || claimData?.type_of_claim === "lost_baggage" || claimData?.type_of_claim === "damage_baggage" || claimData?.type_of_claim === "travel_expenses" || claimData?.type_of_claim === "delayed_baggage" || claimData?.type_of_claim === "others") && claimData?.claim_amount &&<div className="claim-data delay-time" style={{flexDirection:"row",flex:"initial",alignItems:"center",gap:"10px",width:"fit-content",border:"2px solid #eff3f9"}}>

            <label >Claim Amount: </label>
                <span style={{ color: "#222" }}>${claimData?.claim_amount}</span>

          </div>
          }
          </div>


        
          
         

          <div style={{ borderBottom: "1px solid #EFF3F9", padding: "30px 0" }}>
            <h4 className="dashboard-header" style={{ marginBottom: "20px" }}>
              Claim documents
            </h4>

            {claimData.airline_response || claimData.agreement ? (
              <>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                  className="desktop-wrapper"
                >
                  <span
                    style={{
                      fontSize: "18px",
                      lineHeight: "32px",
                      fontWeight: "500",
                      color: "#222222",
                    }}
                  >
                    Documents provided by attorney
                  </span>
                  <span className="sub-header" style={{ fontSize: "14px" }}>
                    {" "}
                    Submitted:{" "}
                    {claimData?.created_date
                      ? moment(claimData.created_date).format("MM/DD/YYYY") +
                        " " +
                        moment(claimData.created_date, "HH:mm").format(
                          "hh:mm A"
                        )
                      : "No Data"}
                  </span>
                </div>

                <div className="claim-document-wrapper">
                  <div className="document-box">
                    <p>Agreement</p>

                      <div className="document-wrapper">
                      <Tooltip label='View File'>
                      <span
                        onClick={() => handleViewFile(claimData.agreement)}
                        className="icon"
                        style={{ backgroundColor: "#799DD2" }}
                      >
                        <DocumentIcon />
                        </span>
                        </Tooltip>
                      <p
                        className="sub-header"
                        style={{ color: "#222222", flex: 1 }}
                      >
                        {truncateText(claimData?.agreement) || "No Agreement"}{" "}
                        {/* <span style={{ color: "#858585" }}>(6.7 MB)</span> */}
                      </p>
                       <Tooltip label='Download'>
                      <span
                        className="icon"
                        style={{ border: "1px solid #314064" }}
                      >
                        <DownloadIcon onClick={handleAgreementDownloadClick} />
                        </span>
                        </Tooltip>
                    </div>

                   
                  
                  </div>

                  {claimData?.airline_poa && (
                    <>
                      <div className="document-box">
                        <p>POA (Airline)</p>
                        <div className="document-wrapper">
                          <Tooltip label='View File'>
                          <span
                            onClick={() =>
                              handleViewFile(claimData.airline_poa)
                            }
                            className="icon"
                            style={{ backgroundColor: "#799DD2" }}
                          >
                            <DocumentIcon />
                            </span>
                            </Tooltip>
                          <p
                            className="sub-header"
                            style={{ color: "#222222", flex: 1 }}
                          >
                            { 
                              getShortUpdatedFilename(
                                claimFiles?.airline_poa,
                                25
                              ) || truncateText(claimData?.airline_poa) ||
                              "No Airline POA"}{" "}
                            {/* <span style={{ color: "#858585" }}>(6.7 MB)</span> */}
                          </p>
                          {claimData?.airline_poa && (
                            <>
                              {" "}
                              <input
                                style={{ display: "none" }}
                                ref={poaRef}
                                onChange={(e) =>
                                  handleUpdatedFileChange(e, "airline_poa")
                                }
                                type="file"
                                className="form-control mt-2"
                                name="airline_poa"
                              />

                              {/* <Tooltip label='Edit File'>
                              <span
                                onClick={() => poaRef.current.click()}
                                className="icon"
                                style={{ border: "1px solid rgb(49, 64, 100)" }}
                              >
                                <svg
                                  width="18px"
                                  height="18px"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g
                                    id="SVGRepo_bgCarrier"
                                    stroke-width="0"
                                  ></g>
                                  <g
                                    id="SVGRepo_tracerCarrier"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  ></g>
                                  <g id="SVGRepo_iconCarrier">
                                    {" "}
                                    <path
                                      d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z"
                                      stroke="#314064"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    ></path>{" "}
                                    <path
                                      d="M21 21H12"
                                      stroke="#314064"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    ></path>{" "}
                                  </g>
                                </svg>
                                </span>
                                </Tooltip> */}
                            </>
                          )}

                          {claimData?.airline_poa && (
                            <Tooltip label='Download'>
                            <span
                              onClick={() =>
                                handleDownloadClick(claimData?.airline_poa)
                              }
                              className="icon"
                              style={{ border: "1px solid #314064" }}
                            >
                              <DownloadIcon />
                              </span>
                              </Tooltip>
                          )}
                        </div>
                      </div>
                    </>
                  )}


                    {claimData?.power_of_attorney && (
                    <>
                      <div className="document-box">
                        <p>Power Of Attorney</p>
                        <div className="document-wrapper">
                          <Tooltip label='View File'>
                          <span
                            onClick={() =>
                              handleViewFile(claimData.power_of_attorney)
                            }
                            className="icon"
                            style={{ backgroundColor: "#799DD2" }}
                          >
                            <DocumentIcon />
                            </span>
                            </Tooltip>
                          <p
                            className="sub-header"
                            style={{ color: "#222222", flex: 1 }}
                          >
                            { 
                              getShortUpdatedFilename(
                                claimFiles?.power_of_attorney,
                                25
                              ) || truncateText(claimData?.power_of_attorney) ||
                              "No Power of Attorney"}{" "}
                            {/* <span style={{ color: "#858585" }}>(6.7 MB)</span> */}
                          </p>
                          {claimData?.power_of_attorney && (
                            <>
                              {" "}
                              <input
                                style={{ display: "none" }}
                                ref={poaRef}
                                onChange={(e) =>
                                  handleUpdatedFileChange(e, "power_of_attorney")
                                }
                                type="file"
                                className="form-control mt-2"
                                name="power_of_attorney"
                              />

                              {/* <Tooltip label='Edit File'>
                              <span
                                onClick={() => powerOfAttorneyRef.current.click()}
                                className="icon"
                                style={{ border: "1px solid rgb(49, 64, 100)" }}
                              >
                                <svg
                                  width="18px"
                                  height="18px"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g
                                    id="SVGRepo_bgCarrier"
                                    stroke-width="0"
                                  ></g>
                                  <g
                                    id="SVGRepo_tracerCarrier"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  ></g>
                                  <g id="SVGRepo_iconCarrier">
                                    {" "}
                                    <path
                                      d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z"
                                      stroke="#314064"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    ></path>{" "}
                                    <path
                                      d="M21 21H12"
                                      stroke="#314064"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    ></path>{" "}
                                  </g>
                                </svg>
                                </span>
                                </Tooltip> */}
                            </>
                          )}

                          {claimData?.power_of_attorney && (
                            <Tooltip label='Download'>
                            <span
                              onClick={() =>
                                handleDownloadClick(claimData?.power_of_attorney)
                              }
                              className="icon"
                              style={{ border: "1px solid #314064" }}
                            >
                              <DownloadIcon />
                              </span>
                              </Tooltip>
                          )}
                        </div>
                      </div>
                    </>
                  )} 

                  {claimData.type_of_claim === "lost/damaged" && claimData?.baggage_claim && (
                    <>
                      <div className="document-box">
                        <p>Baggage Claim</p>
                        <div className="document-wrapper">
                            <Tooltip label='View File'>

                          <span
                            onClick={() =>
                              handleViewFile(claimData.baggage_claim)
                            }
                            className="icon"
                            style={{ backgroundColor: "#799DD2" }}
                          >
                            <DocumentIcon />
                            </span>
                            </Tooltip>
                          <p
                            className="sub-header"
                            style={{ color: "#222222", flex: 1 }}
                          >
                            {truncateText(claimData?.baggage_claim) ||
                              getShortUpdatedFilename(
                                claimFiles?.baggage_claim,
                                25
                              ) ||
                              "No Baggage Claim"}{" "}
                            {/* <span style={{ color: "#858585" }}>(6.7 MB)</span> */}
                          </p>
                          {!claimData?.baggage_claim && (
                            <>
                              {" "}
                              <input
                                style={{ display: "none" }}
                                ref={baggageClaimRef}
                                onChange={(e) =>
                                  handleUpdatedFileChange(e, "baggage_claim")
                                }
                                type="file"
                                className="form-control mt-2"
                                name="baggage_claim"
                              />
                              {/* <Tooltip label='Edit File'>
                              <span
                                onClick={() => baggageClaimRef.current.click()}
                                className="icon"
                                style={{ border: "1px solid rgb(49, 64, 100)" }}
                              >
                                <svg
                                  width="18px"
                                  height="18px"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g
                                    id="SVGRepo_bgCarrier"
                                    stroke-width="0"
                                  ></g>
                                  <g
                                    id="SVGRepo_tracerCarrier"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  ></g>
                                  <g id="SVGRepo_iconCarrier">
                                    {" "}
                                    <path
                                      d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z"
                                      stroke="#314064"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    ></path>{" "}
                                    <path
                                      d="M21 21H12"
                                      stroke="#314064"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    ></path>{" "}
                                  </g>
                                </svg>
                                </span>
                                </Tooltip> */}
                            </>
                          )}

                          {claimData?.baggage_claim && (
                              <Tooltip label='Download'>
                            
                            <span
                              onClick={() =>
                                handleDownloadClick(claimData?.baggage_claim)
                              }
                              className="icon"
                              style={{ border: "1px solid #314064" }}
                            >
                              <DownloadIcon />
                              </span>
                              </Tooltip>
                          )}
                        </div>
                      </div>

                      {
                        claimData?.additional_exp &&  <div className="document-box">
                        <p>Additional Expenses</p>
                        <div className="document-wrapper">
                             <Tooltip label='View File'>

                          <span
                            onClick={() =>
                              handleViewFile(claimData.additional_exp)
                            }
                            className="icon"
                            style={{ backgroundColor: "#799DD2" }}
                          >
                            <DocumentIcon />
                            </span>
                            </Tooltip>
                          <p
                            className="sub-header"
                            style={{ color: "#222222", flex: 1 }}
                          >
                            {truncateText(claimData?.additional_exp) ||
                              getShortUpdatedFilename(
                                claimFiles?.additional_exp,
                                25
                              ) ||
                              "No Additional Expences"}{" "}
                            {/* <span style={{ color: "#858585" }}>(6.7 MB)</span> */}
                          </p>

                          {!claimData?.additional_exp && (
                            <>
                              {" "}
                              <input
                                style={{ display: "none" }}
                                ref={additionalExpencesRef}
                                onChange={(e) =>
                                  handleUpdatedFileChange(e, "additional_exp")
                                }
                                type="file"
                                className="form-control mt-2"
                                name="additional_exp"
                              />
                             {/* <Tooltip label='Edit File'>

                              <span
                                onClick={() =>
                                  additionalExpencesRef.current.click()
                                }
                                className="icon"
                                style={{ border: "1px solid rgb(49, 64, 100)" }}
                              >
                                <svg
                                  width="18px"
                                  height="18px"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g
                                    id="SVGRepo_bgCarrier"
                                    stroke-width="0"
                                  ></g>
                                  <g
                                    id="SVGRepo_tracerCarrier"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  ></g>
                                  <g id="SVGRepo_iconCarrier">
                                    {" "}
                                    <path
                                      d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z"
                                      stroke="#314064"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    ></path>{" "}
                                    <path
                                      d="M21 21H12"
                                      stroke="#314064"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    ></path>{" "}
                                  </g>
                                </svg>
                                </span>
                                </Tooltip> */}
                            </>
                          )}

                          {claimData?.additional_exp && (
                             <Tooltip label='Download'>
                            <span
                              onClick={() =>
                                handleDownloadClick(claimData?.additional_exp)
                              }
                              className="icon"
                              style={{ border: "1px solid #314064" }}
                            >
                              <DownloadIcon />
                              </span>
                              </Tooltip>
                          )}
                        </div>
                      </div>
                      }
                     
                    </>
                  )}
                </div>

              </>
            ) : (
              <span
                style={{
                  fontSize: "18px",
                  lineHeight: "32px",
                  fontWeight: "500",
                  color: "#222222",
                }}
              >
                No Documents Available yet
              </span>
            )}
          </div>

          {/* <h4 className="dashboard-header mobile-wrapper">Upload documents</h4> */}
          <div>
  <h4 className="dashboard-header">Addtional documents</h4>
          {
            memberAddtionalDoc.every(doc => doc.document === null) && <div>No 
additional documents uploaded yet
              </div>
              }
          </div>
        
              

                
        
          {/* <div className="edit-claim-border upload-file-claim">
            <div
              style={{ display: "flex", flexDirection: "column", gap: "10px" }}
            >
              <span
                style={{
                  fontSize: "18px",
                  lineHeight: "32px",
                  fontWeight: "500",
                  color: "#222222",
                }}
                className="desktop-wrapper"
              >
                Upload additional documents
              </span>
              <span className="sub-header">
                Supported formats: PDF, JPG, PNG.
              </span>
            </div>
            <CustomButton
              type="secondary"
              btnText={"Upload document"}
              onClick={() => {
                addionalFilesRef.current.click();
              }}
            />

            <input
              style={{ display: "none" }}
              ref={addionalFilesRef}
              onChange={(e) => handleUpdatedAddionalFileChange(e)}
              type="file"
              className="form-control mt-2"
              name="addtional_files"
              multiple
            />
           
          </div> */}

          <div>
            {/* <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  marginTop: "30px",
                  marginBottom: "30px",
                }}
              >
                <h4
                  style={{ fontSize: "17px", fontWeight: 500, marginBottom: 0 }}
                >
                  Additonal Documents
                </h4>

                <input
                  style={{ display: "none" }}
                  ref={addionalFilesRef}
                  onChange={(e) => handleUpdatedAddionalFileChange(e)}
                  type="file"
                  className="form-control mt-2"
                  name="addtional_files"
                  multiple
                />
                <span
                  className="individual-claim-view-file-button"
                  onClick={() => {
                    addionalFilesRef.current.click();
                  }}
                  style={{
                    borderRadius: "4px",
                    height: "100%",
                    cursor: "pointer",
                  }}
                >
                  <svg
                    width="18px"
                    height="18px"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g
                      id="SVGRepo_tracerCarrier"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></g>
                    <g id="SVGRepo_iconCarrier">
                      {" "}
                      <path
                        d="M13.5 3H12H8C6.34315 3 5 4.34315 5 6V18C5 19.6569 6.34315 21 8 21H11M13.5 3L19 8.625M13.5 3V7.625C13.5 8.17728 13.9477 8.625 14.5 8.625H19M19 8.625V11.8125"
                        stroke="#314064"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>{" "}
                      <path
                        d="M17 15V18M17 21V18M17 18H14M17 18H20"
                        stroke="#314064"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>{" "}
                    </g>
                  </svg>
                </span>
              </div> */}
            <div
              className="claim-data-wrapper addtional-data-wrapper"
              style={{
                padding: "0 0 20px 0",
                marginTop: "0",
                justifyContent: "flex-start",
                flexWrap: "wrap",
              }}
            >
              {memberAddtionalDoc?.map((doc, index) => (
                doc?.document !== null && (  <div
                  className="claim-data"
                  key={doc.id}
                  style={{ width: "293px", maxWidth: "293px", flex: "none" }}
                >
                  <label>Additional Document {index + 1}:</label>
                  <button
                    className={`individual-claim-view-file-button`}
                    onClick={() => handleViewFile(doc.document)}
                    disabled={!doc.document}
                    style={{
                      ...(doc.document ? {} : { cursor: "not-allowed" }),
                      marginTop: "10px",
                    }}
                    type="button"
                  >
                    {/* {doc.document ? "View File" : "No File"} */}
                    <DocumentIcon />
                    {doc.document
                      ? getShortenedFileName(doc.document)
                      : "No File"}
                  </button>
                </div>)
               
              ))}

              {addtionalFiles?.map((doc, index) => (
                <div
                  className="claim-data"
                  key={index}
                  style={{ width: "293px", maxWidth: "293px", flex: "none" }}
                >
                  <label>Additional Document {otherDoc.length + (index + 1)}:</label>
                  <button
                    className={`individual-claim-view-file-button`}
                    onClick={() => handleViewUpdatedFile(doc)}
                    style={{
                      marginTop: "10px",
                    }}
                    type="button"
                  >
                    {/* {doc.document ? "View File" : "No File"} */}
                    <DocumentIcon />
                    {doc ? getShortUpdatedFilename(doc) : "No File"}
                  </button>
                </div>
              ))}
            </div>
          </div>

          <div style={{ padding: "20px 0" }} className="payment-status-wrapper">
            <h6 className="dashboard-header">Payment status</h6>
            {getpaymentData && getpaymentData.length > 0 ? (
              getpaymentData.map((paymentData, index) => (
                <>
                  <div className="claim-data-wrapper edit-claim-border ">
                    <div className="claim-data">
                      <label
                        className="sub-header"
                        style={{ color: "#222222" }}
                      >
                        Payment sent
                      </label>
                      <span>
                        {" "}
                        {paymentData.payment_sent_at
                          ? moment(paymentData.payment_sent_at).format(
                              "MM/DD/YYYY"
                            )
                          : null}
                      </span>
                    </div>

                    <div className="claim-data">
                      <label
                        className="sub-header"
                        style={{ color: "#222222" }}
                      >
                        Payment method
                      </label>
                      <span>{paymentData.payment_method}</span>
                    </div>

                    <div className="claim-data">
                      <label
                        className="sub-header"
                        style={{ color: "#222222" }}
                      >
                        Status
                      </label>
                      <span
                        style={{
                          textTransform: "capitalize",
                          borderRadius: "16px",
                          padding: "4px 16px",
                          width: "fit-content",
                          backgroundColor:
                            statusTwo === "In review"
                              ? "rgba(255, 193, 7, 0.1)" // yellow (light)
                              : statusTwo === "Waiting for airline"
                              ? "rgba(229, 116, 45, 0.1)" // orange (unchanged)
                              : statusTwo === "Documents needed"
                              ? "rgba(208, 66, 68, 0.1)" // red (unchanged)
                              : statusTwo === "paid"
                              ? "rgba(33, 150, 243, 0.1)" // blue (light)
                              : statusTwo === "approved"
                              ? "rgba(76, 175, 80, 0.1)" // green (optional, since not specified)
                              : statusTwo === "appealed"
                              ? "rgba(255, 152, 0, 0.1)" // deep orange
                              : statusTwo === "rejected"
                              ? "rgba(244, 67, 54, 0.1)" // red (stronger)
                              : statusTwo === "incomplete"
                              ? "rgba(158, 158, 158, 0.1)" // grey
                              : statusTwo === "pending"
                              ? "rgba(255, 152, 0, 0.1)" // orange
                              : "rgba(0, 0, 0, 0.1)", // default
                          color:
                            statusTwo === "In review"
                              ? "#FFC107" // yellow
                              : statusTwo === "Waiting for airline"
                              ? "#E5742D" // orange (unchanged)
                              : statusTwo === "Documents needed"
                              ? "#D04244" // red (unchanged)
                              : statusTwo === "paid"
                              ? "#2196F3" // blue
                              : statusTwo === "approved"
                              ? "#4CAF50" // green
                              : statusTwo === "appealed"
                              ? "#FF9800" // deep orange
                              : statusTwo === "rejected"
                              ? "#F44336" // red
                              : statusTwo === "incomplete"
                              ? "#9E9E9E" // grey
                              : statusTwo === "pending"
                              ? "#FF9800" // orange
                              : "rgba(0, 0, 0, 1)", // default
                        }}
                      >
                        {paymentData.payment_status}
                      </span>
                    </div>

                    <div className="claim-data">
                      <label
                        className="sub-header"
                        style={{ color: "#222222" }}
                      >
                        Amount
                      </label>
                      <span>€ {paymentData.amount}</span>
                    </div>
                  </div>
                </>
              ))
            ) : (
              <div>No Payment Data available</div>
            )}
          </div>

          {/* <div>
            <h4 className="dashboard-header">Messages</h4>
            <div style={{ marginTop: "30px" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "15px",
                  borderBottom: "1px solid #EFF3F9",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <FlyClaimIcon />
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <span className="sub-header">
                      Claim #12345 – final review update
                    </span>
                    <span className="sub-header" style={{ fontSize: "14px" }}>
                      08/01/2024
                    </span>
                  </div>
                </div>
                <CustomButton btnText={"View"} type="secondary" />
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "15px",
                  borderBottom: "1px solid #EFF3F9",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <FlyClaimIcon />
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <span className="sub-header">
                      Claim #12345 – final review update
                    </span>
                    <span className="sub-header" style={{ fontSize: "14px" }}>
                      08/01/2024
                    </span>
                  </div>
                </div>
                <CustomButton btnText={"View"} type="secondary" />
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "15px",
                  borderBottom: "1px solid #EFF3F9",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <FlyClaimIcon />
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <span className="sub-header">
                      Claim #12345 – final review update
                    </span>
                    <span className="sub-header" style={{ fontSize: "14px" }}>
                      08/01/2024
                    </span>
                  </div>
                </div>
                <CustomButton btnText={"View"} type="secondary" />
              </div>
            </div>
          </div> */}

          <div>
            <h2 className="individual-header">Attorney / Client Notes</h2>
            <h4 className="dashboard-header">
              Comments ({previousNote?.length ?? 0})
            </h4>
            <div>
               <div className="dashboard-comments-main-container mobile-dashboard-comments">
                {previousNote && previousNote.length > 0 ? (
                  previousNote.map((note, index) => (
                    <>
                      <div
                        className="comment-box-wrapper"
                        key={index}
                        style={{
                          backgroundColor: index % 2 === 0 ? "#EFF3F9" : "#fff",
                        }}
                      >
                        <div className="comment-box-header-wrapper">
                          <div className="comment-name-wrapper">
                            {note.user === "customer" ? (
                              <Avatar />
                            ) : (
                              <FlyClaimIcon />
                            )}

                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <span className="name">
                                {note.user.charAt(0).toUpperCase() +
                                  note.user.slice(1)}
                              </span>
                              <span className="designation">
                                {note.timestamp}
                              </span>
                            </div>
                          </div>

                          {note.user !== "Lawyer" && (
                            <Menu
                              shadow="md"
                              width={175}
                              styles={{
                                dropdown: { borderRadius: "12px" },
                              }}
                            >
                              <Menu.Target>
                                <span style={{ cursor: "pointer" }}>
                                  <DotsHorizontalIcon />
                                </span>
                              </Menu.Target>
                              <Menu.Dropdown>
                                <Menu.Item
                                  onClick={() => setNoteEditFieldOpen(index)}
                                  leftSection={<EditButtonIcon />}
                                >
                                  Edit comment
                                </Menu.Item>
                                <Menu.Item
                                  onClick={() => userNoteDelete(index)}
                                  leftSection={<TrashIcon />}
                                >
                                  Delete
                                </Menu.Item>
                              </Menu.Dropdown>
                            </Menu>
                          )}
                        </div>
                        <div className="comment-text-box">
                          <p>{note.note}</p>
                          {note?.edited && (
                            <span className="designation">
                              Edited {note.edited} •
                            </span>
                          )}
                        </div>

                        {note?.files && note?.files.length > 0 && (
                          <div className="edit-claim-note-files-container">
                            {note?.files?.map((fileUrl, index) => {
                              if (!fileUrl) return null;
                              const fileName = fileUrl?.split("/").pop();
                              const shortenedName =
                                fileName.length > 20
                                  ? `${fileName.slice(0, 20)}...`
                                  : fileName;
                              return (
                                <div
                                  onClick={() => handleViewFile(fileUrl)}
                                  key={index}
                                  className="edit-claim-note-files"
                                >
                                  <DocumentIcon style={{ marginRight: 8 }} />
                                  {shortenedName}
                                </div>
                              );
                            })}
                          </div>
                        )}
                        {noteEditFieldOpen === index && (
                          <div className="editfield-main-container">
                            <div className="editfield-container">
                              <div className="editfield-box">
                                <p>Edit your message</p>
                                <textarea
                                  value={editUserNote}
                                  onChange={(e) =>
                                    handleUserEditNoteInputChange(e)
                                  }
                                  placeholder="Write your comment here..."
                                />
                              </div>
                              <span
                                onClick={() => setNoteEditFieldOpen(null)}
                                style={{ cursor: "pointer" }}
                              >
                                <EditCrossIcon className="mobile-close" />
                              </span>
                            </div>
                            {editSelectedFiles &&
                              editSelectedFiles.length > 0 && (
                                <div className="edit-claim-addfile-conatiner">
                                  {editSelectedFiles.map(({ file }, index) => {
                                    const fileName = file.name;
                                    const shortenedName =
                                      fileName.length > 10
                                        ? `${fileName.slice(0, 10)}...`
                                        : fileName;
                                    return (
                                      <div
                                        key={index}
                                        className="edit-claim-note-files"
                                      >
                                        <DocumentIcon
                                          style={{ marginRight: 8 }}
                                        />
                                        {shortenedName}
                                      </div>
                                    );
                                  })}
                                </div>
                              )}
                            <div className="dashboard-input-buttons-box">
                              <Menu
                                shadow="md"
                                width={150}
                                styles={{
                                  dropdown: { borderRadius: "12px" },
                                }}
                              >
                                <Menu.Target>
                                  <span style={{ cursor: "pointer" }}>
                                    <AttachmentIcon />
                                  </span>
                                </Menu.Target>
                                <Menu.Dropdown>
                                  <Menu.Item
                                    onClick={() => openEditFilePicker("image")}
                                    leftSection={<ImageIcon />}
                                  >
                                    Image
                                  </Menu.Item>
                                  <Menu.Item
                                    onClick={() => openEditFilePicker("file")}
                                    leftSection={<DocumentFileIcon />}
                                  >
                                    File
                                  </Menu.Item>
                                </Menu.Dropdown>
                              </Menu>
                              <span
                                onClick={(e) => userNoteEditSubmit(e, index)}
                                style={{ cursor: "pointer" }}
                              >
                                <EditTickButton />
                              </span>
                            </div>
                          </div>
                        )}
                      </div>
                    </>
                  ))
                ) : (
                  <div>No notes available</div>
                )}
              </div>
              <div className="dashboard-comments-main-container">
                <div className="dashboard-input-box">
                  <textarea
                    value={userNote}
                    onChange={handleUserNoteInputChange}
                    placeholder="Write your comment here..."
                  />
                  {selectedFiles && selectedFiles.length > 0 && (
                    <div className="edit-claim-addfile-conatiner">
                      {selectedFiles.map(({ file }, index) => {
                        const fileName = file.name;
                        const shortenedName =
                          fileName.length > 10
                            ? `${fileName.slice(0, 10)}...`
                            : fileName;
                        return (
                          <div key={index} className="edit-claim-note-files">
                            <DocumentIcon style={{ marginRight: 8 }} />
                            {shortenedName}
                          </div>
                        );
                      })}
                    </div>
                  )}
                  <div className="dashboard-input-buttons-box">
                    {/* <div className="edit-claim-addfile-conatiner"> */}
                    <Menu
                      shadow="md"
                      width={150}
                      styles={{ dropdown: { borderRadius: "12px" } }}
                    >
                      <Menu.Target>
                        <span style={{ cursor: "pointer" }}>
                          <AttachmentIcon />
                        </span>
                      </Menu.Target>
                      <Menu.Dropdown>
                        <Menu.Item
                          onClick={() => openFilePicker("image")}
                          leftSection={<ImageIcon />}
                        >
                          Image
                        </Menu.Item>
                        <Menu.Item
                          onClick={() => openFilePicker("file")}
                          leftSection={<DocumentFileIcon />}
                        >
                          File
                        </Menu.Item>
                      </Menu.Dropdown>
                    </Menu>

                    {/* </div> */}
                    <span
                      onClick={(e) => handleUserNoteSubmit(e)}
                      style={{ cursor: "pointer" }}
                    >
                      <CommentButtonIcon />
                    </span>
                  </div>
                </div>
              </div>
             
            </div>
          </div>



          <div style={{ marginTop: "40px" }}>
            
            <h4 className="dashboard-header">
              Customer Service / Client Notes ({customerCareNote?.length ?? 0})
              {/* Comments ({customerCareNote?.length ?? 0}) */}
            </h4>
            <div>
               <div className="dashboard-comments-main-container mobile-dashboard-comments">
                {customerCareNote && customerCareNote.length > 0 ? (
                  customerCareNote.map((note, index) => (
                    <>
                      <div
                        className="comment-box-wrapper"
                        key={index}
                        style={{
                          backgroundColor: index % 2 === 0 ? "#EFF3F9" : "#fff",
                        }}
                      >
                        <div className="comment-box-header-wrapper">
                          <div className="comment-name-wrapper">
                            {note.user === "customer" ? (
                              <Avatar />
                            ) : (
                              <FlyClaimIcon />
                            )}

                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <span className="name">
                                {note.user.charAt(0).toUpperCase() +
                                  note.user.slice(1)}
                              </span>
                              <span className="designation">
                                {note.timestamp}
                              </span>
                            </div>
                          </div>

                          {note.user !== "Customer Service" && (
                            <Menu
                              shadow="md"
                              width={175}
                              styles={{
                                dropdown: { borderRadius: "12px" },
                              }}
                            >
                              <Menu.Target>
                                <span style={{ cursor: "pointer" }}>
                                  <DotsHorizontalIcon />
                                </span>
                              </Menu.Target>
                              <Menu.Dropdown>
                                <Menu.Item
                                  onClick={() => setCustomerNoteEditFieldOpen(index)}
                                  leftSection={<EditButtonIcon />}
                                >
                                  Edit comment
                                </Menu.Item>
                                <Menu.Item
                                  onClick={() => customerUserNoteDelete(index)}
                                  leftSection={<TrashIcon />}
                                >
                                  Delete
                                </Menu.Item>
                              </Menu.Dropdown>
                            </Menu>
                          )}
                        </div>
                        <div className="comment-text-box">
                          <p>{note.note}</p>
                          {note?.edited && (
                            <span className="designation">
                              Edited {note.edited} •
                            </span>
                          )}
                        </div>

                        {note?.files && note?.files.length > 0 && (
                          <div className="edit-claim-note-files-container">
                            {note?.files?.map((fileUrl, index) => {
                              if (!fileUrl) return null;
                              const fileName = fileUrl?.split("/").pop();
                              const shortenedName =
                                fileName.length > 20
                                  ? `${fileName.slice(0, 20)}...`
                                  : fileName;
                              return (
                                <div
                                  onClick={() => handleViewFile(fileUrl)}
                                  key={index}
                                  className="edit-claim-note-files"
                                >
                                  <DocumentIcon style={{ marginRight: 8 }} />
                                  {shortenedName}
                                </div>
                              );
                            })}
                          </div>
                        )}
                        {customerNoteEditFieldOpen === index && (
                          <div className="editfield-main-container">
                            <div className="editfield-container">
                              <div className="editfield-box">
                                <p>Edit your message</p>
                                <textarea
                                  value={editCustomerUserNote}
                                  onChange={(e) =>
                                    handleCustomerUserEditNoteInputChange(e)
                                  }
                                  placeholder="Write your comment here..."
                                />
                              </div>
                              <span
                                onClick={() => setCustomerNoteEditFieldOpen(null)}
                                style={{ cursor: "pointer" }}
                              >
                                <EditCrossIcon className="mobile-close" />
                              </span>
                            </div>
                            {editSelectedCustomerFiles &&
                              editSelectedCustomerFiles.length > 0 && (
                                <div className="edit-claim-addfile-conatiner">
                                  {editSelectedCustomerFiles.map(({ file }, index) => {
                                    const fileName = file.name;
                                    const shortenedName =
                                      fileName.length > 10
                                        ? `${fileName.slice(0, 10)}...`
                                        : fileName;
                                    return (
                                      <div
                                        key={index}
                                        className="edit-claim-note-files"
                                      >
                                        <DocumentIcon
                                          style={{ marginRight: 8 }}
                                        />
                                        {shortenedName}
                                      </div>
                                    );
                                  })}
                                </div>
                              )}
                            <div className="dashboard-input-buttons-box">
                              <Menu
                                shadow="md"
                                width={150}
                                styles={{
                                  dropdown: { borderRadius: "12px" },
                                }}
                              >
                                <Menu.Target>
                                  <span style={{ cursor: "pointer" }}>
                                    <AttachmentIcon />
                                  </span>
                                </Menu.Target>
                                <Menu.Dropdown>
                                  <Menu.Item
                                    onClick={() => openEditCutomerFilePicker("image")}
                                    leftSection={<ImageIcon />}
                                  >
                                    Image
                                  </Menu.Item>
                                  <Menu.Item
                                    onClick={() => openEditCutomerFilePicker("file")}
                                    leftSection={<DocumentFileIcon />}
                                  >
                                    File
                                  </Menu.Item>
                                </Menu.Dropdown>
                              </Menu>
                              <span
                                onClick={(e) => customerUserNoteEditSubmit(e, index)}
                                style={{ cursor: "pointer" }}
                              >
                                <EditTickButton />
                              </span>
                            </div>
                          </div>
                        )}
                      </div>
                    </>
                  ))
                ) : (
                  <div>No notes available</div>
                )}
              </div>
              <div className="dashboard-comments-main-container">
                <div className="dashboard-input-box">
                  <textarea
                    value={customerUserNote}
                    onChange={(e) => setCustomerUserNote(e.target.value)}
                    placeholder="Write your comment here..."
                  />
                  {customerSelectedFiles && customerSelectedFiles.length > 0 && (
                    <div className="edit-claim-addfile-conatiner">
                      {customerSelectedFiles.map(({ file }, index) => {
                        const fileName = file.name;
                        const shortenedName =
                          fileName.length > 10
                            ? `${fileName.slice(0, 10)}...`
                            : fileName;
                        return (
                          <div key={index} className="edit-claim-note-files">
                            <DocumentIcon style={{ marginRight: 8 }} />
                            {shortenedName}
                          </div>
                        );
                      })}
                    </div>
                  )}
                  <div className="dashboard-input-buttons-box">
                    {/* <div className="edit-claim-addfile-conatiner"> */}
                    <Menu
                      shadow="md"
                      width={150}
                      styles={{ dropdown: { borderRadius: "12px" } }}
                    >
                      <Menu.Target>
                        <span style={{ cursor: "pointer" }}>
                          <AttachmentIcon />
                        </span>
                      </Menu.Target>
                      <Menu.Dropdown>
                        <Menu.Item
                          onClick={() => openCustomerFilePicker("image")}
                          leftSection={<ImageIcon />}
                        >
                          Image
                        </Menu.Item>
                        <Menu.Item
                          onClick={() => openCustomerFilePicker("file")}
                          leftSection={<DocumentFileIcon />}
                        >
                          File
                        </Menu.Item>
                      </Menu.Dropdown>
                    </Menu>

                    {/* </div> */}
                    <span
                      onClick={(e) => handleCustomerUserNoteSubmit(e)}
                      style={{ cursor: "pointer" }}
                    >
                      <CommentButtonIcon />
                    </span>
                  </div>
                </div>
              </div>
             
            </div>
          </div>

         {/* removed date 11 Nov 25 */}

           {/* <div
            className="table-wrapper desktop-wrapper"
            style={{ padding: "20px 0" }}
          >
            <h4 className="dashboard-header">Claim timeline</h4>
            <Table
              className="edit-claim-border"
              striped
              stripedColor="#F4F8FF"
              withRowBorders={false}
            >
              <Table.Thead>
                <Table.Tr>
                  <Table.Th>Submitted date</Table.Th>

                  <Table.Th>Status</Table.Th>
                  <Table.Th>Notes</Table.Th>
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody>
                {previousTimeline && previousTimeline.length > 0 ? (
                  previousTimeline.map((timelinenote, index) => (
                    <Table.Tr key={index}>
                      <Table.Td>
                        {" "}
                        {timelinenote.created_date
                          ? moment(timelinenote.created_date).format(
                              "MM/DD/YYYY hh:mm A"
                            )
                          : null}
                      </Table.Td>
                      <Table.Td> {timelinenote.status}</Table.Td>
                      <Table.Td>{timelinenote.notes}</Table.Td>
                    </Table.Tr>
                  ))
                ) : (
                  <p style={{ margin: "10px 10px" }}>No Timeline available</p>
                )}
              </Table.Tbody>
            </Table>
          </div>

          <div className="mobile-timeline-wrapper mobile-wrapper">
            <h4 className="dashboard-header  " style={{ marginBottom: "10px" }}>
              Claim timeline{" "}
            </h4>

            {previousTimeline && previousTimeline.length > 0 ? (
              previousTimeline.map((timelinenote, index) => (
                <div
                  className="timeline-wrapper"
                  key={index}
                  style={{
                    width: "100%",
                    border: "1px solid #E9E9E9",
                    padding: "20px",
                    borderRadius: "16px",
                  }}
                >
                  <div style={{ display: "flex" }}>
                    <div
                      style={{
                        flex: 2,
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                      }}
                    >
                      <span className="sub-header">Submitted date</span>
                      <span
                        style={{
                          fontSize: "14px",
                          lineHeight: "20px",
                          color: "#222222",
                        }}
                      >
                        {timelinenote.created_date
                          ? moment(timelinenote.created_date).format(
                              "MM/DD/YYYY hh:mm A"
                            )
                          : null}
                      </span>
                    </div>
                    <div
                      style={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                      }}
                    >
                      <span className="sub-header">Status</span>

                      <span
                        style={{
                          fontSize: "14px",
                          lineHeight: "20px",
                          color: "#222222",
                        }}
                      >
                        {timelinenote.status}
                      </span>
                    </div>
                  </div>
                  <hr style={{ color: "#CBDAF0" }} />
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                    }}
                  >
                    <span className="sub-header">Notes</span>

                    <span
                      style={{
                        fontSize: "14px",
                        lineHeight: "20px",
                        color: "#222222",
                      }}
                    >
                      {timelinenote.notes}
                    </span>
                  </div>
                </div>
              ))
            ) : (
              <p style={{ margin: "10px 10px" }}>No Timeline available</p>
            )}
          </div> */}


           <div
            style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
          >
            <CustomButton
              type="danger"
              btnText={"Delete"}
              onClick={handleDeleteModalOpen}
              style={{ width: "fit-content" }}
            />
            {getIsUpdatedDisable() && (
              <CustomButton
                btnText={"Update"}
                onClick={handleUpdateClaim}
                style={{ width: "fit-content" }}
              />
            )}
          </div>
        </div>
      </div>
      <ViewFileModal
        isOpen={imageModalOpen}
        closeModal={closeImageModal}
        modalTitle={imageModalTitle}
        modalFileUrl={imageModalFileUrl}
      />

      <Modal opened={openedAgreementAlertModal} onClose={closeAgreementAlertModal} closeOnClickOutside={false} withCloseButton={false} centered radius={'lg'} padding={'lg'} size={'lg'}>
        <div style={{display:"flex",flexDirection:'column',gap:'30px',alignItems:'center'}}>
          
          <h4 style={{textAlign:'center'}}>
          
    Your details have changed. Please review and sign the latest agreement to continue.
 </h4>
  

         <CustomButton
                btnText={"Review & Sign"}
            onClick={() => {
              closeAgreementAlertModal()
              setbackdropopen(true);
              setAgreementModalOpen(true)
                }}
                style={{ width: "fit-content" }}
              />
 </div>
  
   
    
  
      </Modal>
      
        <Modal
            opened={documentNoteOpened}
            onClose={() => setDocumentNoteOpened(false)}
        title="Add Document Note"
        radius={'lg'}
            centered
          >
            <textarea
              placeholder="Write your note..."
              value={documentNote}
              onChange={(e) => setDocumentNote(e.target.value)}

             className="document-add-note"
            />

            <div  className="document-note-btn-wrapper">
              <CustomButton btnText={'Close'} type="secondary" color="red" onClick={() => { setDocumentNote(''); setDocumentNoteOpened(false) }}/>
               
              <CustomButton onClick={() => {
               
                setDocumentNoteOpened(false);

                setTimeout(() => {
                  handleUploadDetails(true)
                }, 100);
              }}  btnText={'Add Note'}  disabled={documentNote?.trim() === ""}/>

            </div>
          </Modal>
      <Footer />
    </div>
  );
};

export default IndividualClaim;

// Other's comment options
{
  /* <Menu shadow="md" width={175} styles={{ dropdown: { borderRadius: '12px' } }}>
    <Menu.Target>
      <span style={{ cursor: "pointer" }}> 
        <DotsHorizontalIcon />
      </span>
    </Menu.Target>
    <Menu.Dropdown>
    <Menu.Item leftSection={<TrashIcon />}>
      Delete for both
    </Menu.Item>
    <Menu.Item leftSection={<TrashIcon />}>
      Delete for me
    </Menu.Item>
  </Menu.Dropdown>
</Menu> */
}
